// src/components/features/Interior/data/interiorRoomData.js
// All room types with their questions, options, and display types
// display: "radio"           → (Tick preferable) — plain radio list
// display: "radio_image"     → (Tick preferable with image) — radio + swipe/thumb images
// display: "image_select"    → (Will be shown with images) — image grid select

// ─── REAL KITCHEN IMAGES (from client) ────────────────────────────────────────
// Shape
import kShapeL from "../../../../assets/Interior/Kitchen/Shape/LShape.png";
import kShapeU from "../../../../assets/Interior/Kitchen/Shape/UShape.png";
import kShapeParallel from "../../../../assets/Interior/Kitchen/Shape/Parallel.png";
import kShapeIsland from "../../../../assets/Interior/Kitchen/Shape/Island.png";
// Counter Top
import kCounterGranite from "../../../../assets/Interior/Kitchen/CounterTop/Granite.png";
import kCounterQuartz from "../../../../assets/Interior/Kitchen/CounterTop/Quartz.png";
import kCounterFullBodyTile from "../../../../assets/Interior/Kitchen/CounterTop/FullBodyTile.png";
// Backsplash / Dado
import kDadoSame from "../../../../assets/Interior/Kitchen/Backsplash/SameAsCounter.jpg";
import kDadoDiff from "../../../../assets/Interior/Kitchen/Backsplash/DifferentTile.jpg";
import kDadoGlass from "../../../../assets/Interior/Kitchen/Backsplash/ToughenedGlass.jpg";
// Above Counter Storage
import kStorageWith from "../../../../assets/Interior/Kitchen/AboveCounterStorage/WithOverhead.jpg";
import kStorageWithout from "../../../../assets/Interior/Kitchen/AboveCounterStorage/WithoutOverhead.png";
// RO Position
import kRoAbove from "../../../../assets/Interior/Kitchen/RO/AboveSink.png";
import kRoBelow from "../../../../assets/Interior/Kitchen/RO/BelowSink.jpg";
import kRoWash from "../../../../assets/Interior/Kitchen/RO/InWashArea.png";
// Gas Cylinder
import kGasInside from "../../../../assets/Interior/Kitchen/GasCylinder/Inside.jpg";
import kGasOutside from "../../../../assets/Interior/Kitchen/GasCylinder/Outside.webp";
// Cooking Method
import kCooktop from "../../../../assets/Interior/Kitchen/CookingMethod/Cooktop.jpg";
import kHob from "../../../../assets/Interior/Kitchen/CookingMethod/Hob.jpg";
// Sink
import kSinkSingle from "../../../../assets/Interior/Kitchen/SinkType/SingleBowl.jpg";
import kSinkDouble from "../../../../assets/Interior/Kitchen/SinkType/DoubleBowl.jpg";
import kSinkWithTray from "../../../../assets/Interior/Kitchen/SinkType/WithTray.jpg";
import kSinkWithoutTray from "../../../../assets/Interior/Kitchen/SinkType/WithoutTray.jpg";
// Chimney
import kChimneyWith from "../../../../assets/Interior/Kitchen/Chimney/WithChimney.jpg";
import kChimneyWithout from "../../../../assets/Interior/Kitchen/Chimney/WithoutChimney.jpg";
// Microwave / Oven
import kMicrowaveWith from "../../../../assets/Interior/Kitchen/Microwave/WithMicrowave.png";
import kMicrowaveWithout from "../../../../assets/Interior/Kitchen/Microwave/WithoutMicrowave.png";
// Dishwasher
import kDishwasherWith from "../../../../assets/Interior/Kitchen/Dishwasher/WithDishwasher.jpg";
import kDishwasherWithout from "../../../../assets/Interior/Kitchen/Dishwasher/WithoutDishwasher.jpg";
// Breakfast Counter
import kBreakfastWith from "../../../../assets/Interior/Kitchen/BreakfastCounter/WithCounter.png";
import kBreakfastWithout from "../../../../assets/Interior/Kitchen/BreakfastCounter/WithoutCounter.jpg";
// Handle
import kHandleLess from "../../../../assets/Interior/Kitchen/Handle/HandleLess.jpg";
import kHandleProfile from "../../../../assets/Interior/Kitchen/Handle/ProfileHandle.jpg";
import kHandleSSBrass from "../../../../assets/Interior/Kitchen/Handle/SSBrassHandle.jpg";
// Cabinet
import kCabinetSS from "../../../../assets/Interior/Kitchen/Cabinet/SSTrolley.jpg";
import kCabinetTeendom from "../../../../assets/Interior/Kitchen/Cabinet/TeendomBox.jpg";
// Floor
import kFloorTile from "../../../../assets/Interior/Kitchen/Floor/FloorTile.jpg";
import kFloorMarble from "../../../../assets/Interior/Kitchen/Floor/ItalianMarble.jpg";
import kFloorWood from "../../../../assets/Interior/Kitchen/Floor/WoodenPlanks.jpg";
// Design Themes (12)
import kThemeModern from "../../../../assets/Interior/Kitchen/Theme/Modern.jpg";
import kThemeLuxuryModern from "../../../../assets/Interior/Kitchen/Theme/LuxuryModern.jpg";
import kThemeContemporary from "../../../../assets/Interior/Kitchen/Theme/Contemporary.jpg";
import kThemeMinimalist from "../../../../assets/Interior/Kitchen/Theme/Minimalist.jpg";
import kThemeTraditional from "../../../../assets/Interior/Kitchen/Theme/Traditional.jpg";
import kThemeFarmhouse from "../../../../assets/Interior/Kitchen/Theme/Farmhouse.jpg";
import kThemeScandinavian from "../../../../assets/Interior/Kitchen/Theme/Scandinavian.jpg";
import kThemeBohemian from "../../../../assets/Interior/Kitchen/Theme/Bohemian.jpg";
import kThemeEclectic from "../../../../assets/Interior/Kitchen/Theme/Eclectic.jpg";
import kThemeRetro from "../../../../assets/Interior/Kitchen/Theme/Retro.jpg";
import kThemeMidcentury from "../../../../assets/Interior/Kitchen/Theme/MidcenturyModern.png";
import kThemeRustic from "../../../../assets/Interior/Kitchen/Theme/RusticIndustrial.jpg";
// Color Preference (5)
import kColorDark from "../../../../assets/Interior/Kitchen/Color/Dark.jpg";
import kColorBoldBright from "../../../../assets/Interior/Kitchen/Color/BoldBright.jpg";
import kColorWarm from "../../../../assets/Interior/Kitchen/Color/Warm.jpg";
import kColorCool from "../../../../assets/Interior/Kitchen/Color/Cool.jpg";
import kColorNeutrals from "../../../../assets/Interior/Kitchen/Color/Neutrals.jpg";
// Material Finish
import kFinishGlossy from "../../../../assets/Interior/Kitchen/Finish/GlossyMica.jpg";
import kFinishPVC from "../../../../assets/Interior/Kitchen/Finish/PVCAcrylicMica.jpg";
import kFinishPU from "../../../../assets/Interior/Kitchen/Finish/PUCoating.png";

// ─── REAL BEDROOM IMAGES (from client) ────────────────────────────────────────
// Bed Size
import bBedKing from "../../../../assets/Interior/Bedroom/BedSize/King.jpg";
import bBedQueen from "../../../../assets/Interior/Bedroom/BedSize/Queen.jpg";
import bBedSingle from "../../../../assets/Interior/Bedroom/BedSize/Single.jpg";
// Wardrobe Shutter
import bWardrobeSlider from "../../../../assets/Interior/Bedroom/WardrobeShutter/Slider.jpg";
import bWardrobeOpenable from "../../../../assets/Interior/Bedroom/WardrobeShutter/Openable.jpg";
// Dressing
import bDressInDressRoom from "../../../../assets/Interior/Bedroom/Dressing/InDressRoom.jpg";
import bDressInRoom from "../../../../assets/Interior/Bedroom/Dressing/InRoom.jpg";
// Seating Provision
import bSeatingWith from "../../../../assets/Interior/Bedroom/SeatingProvision/WithSeating.jpg";
import bSeatingWithout from "../../../../assets/Interior/Bedroom/SeatingProvision/WithoutSeating.jpg";
// Wall Treatments
import bWallPanels from "../../../../assets/Interior/Bedroom/WallTreatments/DesignerPanels.jpg";
import bWallWallpaper from "../../../../assets/Interior/Bedroom/WallTreatments/Wallpaper.jpg";
import bWallTextured from "../../../../assets/Interior/Bedroom/WallTreatments/TexturedPaint.jpg";
// Headboard Fabric
import bHeadboardLeather from "../../../../assets/Interior/Bedroom/HeadboardFabric/Leatherette.jpg";
import bHeadboardVelvet from "../../../../assets/Interior/Bedroom/HeadboardFabric/Velvet.jpg";
import bHeadboardLinen from "../../../../assets/Interior/Bedroom/HeadboardFabric/Linen.jpg";
// Curtain Style
import bCurtainFull from "../../../../assets/Interior/Bedroom/CurtainStyle/FullHeight.jpg";
import bCurtainOnWindow from "../../../../assets/Interior/Bedroom/CurtainStyle/OnWindow.jpg";
import bCurtainRoman from "../../../../assets/Interior/Bedroom/CurtainStyle/RomanBlinds.jpg";
import bCurtainSheer from "../../../../assets/Interior/Bedroom/CurtainStyle/SheerBlackout.jpg";
// Floor
import bFloorTile from "../../../../assets/Interior/Bedroom/Floor/Tile.jpg";
import bFloorMarble from "../../../../assets/Interior/Bedroom/Floor/ItalianMarble.jpg";
import bFloorWood from "../../../../assets/Interior/Bedroom/Floor/WoodenPlanks.jpg";
// Material Finish
import bFinishGlossy from "../../../../assets/Interior/Bedroom/Finish/Glossy.png";
import bFinishMatt from "../../../../assets/Interior/Bedroom/Finish/Matt.jpg";
import bFinishSatin from "../../../../assets/Interior/Bedroom/Finish/Satin.jpg";
// Design Theme (representative thumbnail for "Select From Images")
import bThemeModern from "../../../../assets/Interior/Bedroom/Theme/Modern.jpg";
// Color Preference (representative thumbnail for "Select From Images")
import bColorWarm from "../../../../assets/Interior/Bedroom/Color/Warm.jpg";

// ─── REAL LIVING / DRAWING ROOM IMAGES (from client) ──────────────────────────
// Room Type
import lRoomFormal from "../../../../assets/Interior/Living/RoomType/FormalLivingRoom.jpg";
import lRoomLounge from "../../../../assets/Interior/Living/RoomType/FamilyLounge.jpg";
import lRoomTV from "../../../../assets/Interior/Living/RoomType/TVRoom.jpg";
import lRoomCombined from "../../../../assets/Interior/Living/RoomType/CombinedLivingRoom.jpg";
// Sofa Type
import lSofaL from "../../../../assets/Interior/Living/SofaType/LShapeSofa.jpg";
import lSofa32 from "../../../../assets/Interior/Living/SofaType/Sofa3Plus2.jpg";
import lSofaSectional from "../../../../assets/Interior/Living/SofaType/SectionalSofa.jpg";
import lSofaRecliner from "../../../../assets/Interior/Living/SofaType/ReclinerSofa.jpg";
// Seating Capacity
import lSeat4 from "../../../../assets/Interior/Living/SeatingCapacity/Seater4.jpg";
import lSeat6 from "../../../../assets/Interior/Living/SeatingCapacity/Seater6.jpg";
import lSeat8 from "../../../../assets/Interior/Living/SeatingCapacity/Seater8.jpg";
// Center Table
import lTableWood from "../../../../assets/Interior/Living/CenterTable/WoodenTable.jpg";
import lTableGlass from "../../../../assets/Interior/Living/CenterTable/GlassTopTable.jpg";
import lTableMarble from "../../../../assets/Interior/Living/CenterTable/MarbleTopTable.jpg";
import lTableNested from "../../../../assets/Interior/Living/CenterTable/NestedTables.png";
// TV Unit
import lTVWall from "../../../../assets/Interior/Living/TvUnit/WallMountedUnit.jpg";
import lTVDisplay from "../../../../assets/Interior/Living/TvUnit/DisplayWithTVUnit.jpg";
import lTVStorage from "../../../../assets/Interior/Living/TvUnit/StorageWithTVUnit.jpg";
// Display / Showcase Unit
import lDisplayWith from "../../../../assets/Interior/Living/DisplayUnit/WithDisplayUnit.jpg";
import lDisplayWithout from "../../../../assets/Interior/Living/DisplayUnit/WithoutDisplayUnit.jpg";
// Pooja Unit
import lPoojaWith from "../../../../assets/Interior/Living/PoojaUnit/WithPoojaUnit.jpg";
import lPoojaWithout from "../../../../assets/Interior/Living/PoojaUnit/WithoutPoojaUnit.jpg";
// Wall Treatments
import lWallPanels from "../../../../assets/Interior/Living/WallTreatments/DesignerPanels.jpg";
import lWallWallpaper from "../../../../assets/Interior/Living/WallTreatments/Wallpaper.jpg";
import lWallTextured from "../../../../assets/Interior/Living/WallTreatments/TexturedPaint.jpg";
import lWallStone from "../../../../assets/Interior/Living/WallTreatments/StoneCladding.jpg";
// Curtain Style
import lCurtainFull from "../../../../assets/Interior/Living/CurtainStyle/FullHeightCurtain.jpg";
import lCurtainOnWindow from "../../../../assets/Interior/Living/CurtainStyle/OnWindowCurtain.jpg";
import lCurtainRoman from "../../../../assets/Interior/Living/CurtainStyle/RomanBlinds.jpg";
import lCurtainSheer from "../../../../assets/Interior/Living/CurtainStyle/SheerBlackout.jpg";
// Lighting Preference
import lLightChandelier from "../../../../assets/Interior/Living/Lighting/DecorativeChandelier.jpg";
import lLightCove from "../../../../assets/Interior/Living/Lighting/FalseCeilingCoveLight.jpg";
import lLightSpot from "../../../../assets/Interior/Living/Lighting/SpotLights.jpg";
// Floor
import lFloorMarble from "../../../../assets/Interior/Living/Floor/ItalianMarble.jpg";
import lFloorTiles from "../../../../assets/Interior/Living/Floor/Tiles.jpg";
import lFloorWood from "../../../../assets/Interior/Living/Floor/WoodenFlooring.jpg";
// Rug / Carpet
import lRugWith from "../../../../assets/Interior/Living/RugCarpet/WithRug.jpg";
import lRugWithout from "../../../../assets/Interior/Living/RugCarpet/WithoutRug.jpg";
// Design Theme (12)
import lThemeModern from "../../../../assets/Interior/Living/Theme/Modern.jpg";
import lThemeLuxury from "../../../../assets/Interior/Living/Theme/LuxuryModern.jpg";
import lThemeContemporary from "../../../../assets/Interior/Living/Theme/Contemporary.jpg";
import lThemeMinimalist from "../../../../assets/Interior/Living/Theme/Minimalist.jpg";
import lThemeTraditional from "../../../../assets/Interior/Living/Theme/Traditional.jpg";
import lThemeFarmhouse from "../../../../assets/Interior/Living/Theme/Farmhouse.jpg";
import lThemeScandinavian from "../../../../assets/Interior/Living/Theme/Scandinavian.jpg";
import lThemeBohemian from "../../../../assets/Interior/Living/Theme/Bohemian.jpg";
import lThemeEclectic from "../../../../assets/Interior/Living/Theme/Eclectic.jpg";
import lThemeRetro from "../../../../assets/Interior/Living/Theme/Retro.jpg";
import lThemeMidcentury from "../../../../assets/Interior/Living/Theme/MidcenturyModern.jpg";
import lThemeRustic from "../../../../assets/Interior/Living/Theme/RusticIndustrial.jpg";
// Color Preference
import lColorDark from "../../../../assets/Interior/Living/Color/Dark.jpg";
import lColorBoldBright from "../../../../assets/Interior/Living/Color/BoldBright.jpg";
import lColorCool from "../../../../assets/Interior/Living/Color/CoolColors.jpg";
import lColorNeutrals from "../../../../assets/Interior/Living/Color/Neutrals.jpg";
// Material Finish
import lFinishGlossy from "../../../../assets/Interior/Living/Finish/GlossyFinish.jpg";
import lFinishMatt from "../../../../assets/Interior/Living/Finish/MattFinish.jpg";
import lFinishSatin from "../../../../assets/Interior/Living/Finish/SatinFinish.jpg";

// ─── REAL DINING ROOM IMAGES (from client) ────────────────────────────────────
// Dining Type
import dTypeSeparate from "../../../../assets/Interior/Dining/DiningType/SeparateDiningRoom.jpg";
import dTypeOpen from "../../../../assets/Interior/Dining/DiningType/OpenDiningArea.jpg";
import dTypeNook from "../../../../assets/Interior/Dining/DiningType/BreakfastNook.jpg";
// Table Size
import dTable4 from "../../../../assets/Interior/Dining/TableSize/Seater4.jpg";
import dTable6 from "../../../../assets/Interior/Dining/TableSize/Seater6.jpg";
import dTable8 from "../../../../assets/Interior/Dining/TableSize/Seater8.jpg";
// Table Shape
import dShapeRect from "../../../../assets/Interior/Dining/TableShape/Rectangle.jpg";
import dShapeRound from "../../../../assets/Interior/Dining/TableShape/Round.jpg";
import dShapeSquare from "../../../../assets/Interior/Dining/TableShape/Square.jpg";
import dShapeOval from "../../../../assets/Interior/Dining/TableShape/Oval.jpg";
// Crockery Unit
import dCrockeryWith from "../../../../assets/Interior/Dining/CrockeryUnit/WithCrockery.jpg";
import dCrockeryWithout from "../../../../assets/Interior/Dining/CrockeryUnit/WithoutCrockery.jpg";
// Bar Unit
import dBarWith from "../../../../assets/Interior/Dining/BarUnit/WithBarUnit.jpg";
import dBarWithout from "../../../../assets/Interior/Dining/BarUnit/WithoutBarUnit.jpg";
// Wash Basin
import dWashWith from "../../../../assets/Interior/Dining/WashBasin/WithWashBasin.jpg";
import dWashWithout from "../../../../assets/Interior/Dining/WashBasin/WithoutWashBasin.jpg";
// Mirror Wall
import dMirrorWith from "../../../../assets/Interior/Dining/MirrorWall/WithMirrorWall.jpg";
import dMirrorWithout from "../../../../assets/Interior/Dining/MirrorWall/WithoutMirrorWall.jpg";
// Wall Treatments
import dWallPanels from "../../../../assets/Interior/Dining/WallTreatments/DesignerPanels.jpg";
import dWallWallpaper from "../../../../assets/Interior/Dining/WallTreatments/Wallpaper.jpg";
import dWallTextured from "../../../../assets/Interior/Dining/WallTreatments/TexturedPaint.jpg";
import dWallMirror from "../../../../assets/Interior/Dining/WallTreatments/MirrorPanels.jpg";
// Curtain Style
import dCurtainFull from "../../../../assets/Interior/Dining/CurtainStyle/FullHeightCurtain.jpg";
import dCurtainRoman from "../../../../assets/Interior/Dining/CurtainStyle/RomanBlinds.jpg";
// Lighting Preference
import dLightChandelier from "../../../../assets/Interior/Dining/Lighting/Chandelier.jpg";
import dLightCove from "../../../../assets/Interior/Dining/Lighting/CoveLighting.jpg";
// Floor
import dFloorMarble from "../../../../assets/Interior/Dining/Floor/ItalianMarble.jpg";
import dFloorTiles from "../../../../assets/Interior/Dining/Floor/Tiles.jpg";
import dFloorWood from "../../../../assets/Interior/Dining/Floor/WoodenFlooring.jpg";
// Design Theme (9)
import dThemeModern from "../../../../assets/Interior/Dining/Theme/Modern.jpg";
import dThemeContemporary from "../../../../assets/Interior/Dining/Theme/Contemporary.jpg";
import dThemeTraditional from "../../../../assets/Interior/Dining/Theme/Traditional.jpg";
import dThemeFarmhouse from "../../../../assets/Interior/Dining/Theme/Farmhouse.jpg";
import dThemeScandinavian from "../../../../assets/Interior/Dining/Theme/Scandinavian.jpg";
import dThemeBohemian from "../../../../assets/Interior/Dining/Theme/Bohemian.jpg";
import dThemeEclectic from "../../../../assets/Interior/Dining/Theme/Eclectic.jpg";
import dThemeRetro from "../../../../assets/Interior/Dining/Theme/Retro.jpg";
import dThemeRustic from "../../../../assets/Interior/Dining/Theme/RusticIndustrial.jpg";
// Color Preference (3)
import dColorBoldBright from "../../../../assets/Interior/Dining/Color/BoldBright.jpg";
import dColorWarm from "../../../../assets/Interior/Dining/Color/Warm.jpg";
import dColorNeutrals from "../../../../assets/Interior/Dining/Color/Neutrals.jpg";
// Material Finish (2)
import dFinishGlossy from "../../../../assets/Interior/Dining/Finish/GlossyFinish.jpg";
import dFinishMatt from "../../../../assets/Interior/Dining/Finish/MattFinish.jpg";

// ─── REAL DRESSING ROOM IMAGES (from client) ──────────────────────────────────
// Room Type
import drRoomWalkin from "../../../../assets/Interior/Dressing/RoomType/WalkinDressingRoom.jpg";
import drRoomCompact from "../../../../assets/Interior/Dressing/RoomType/CompactDressArea.jpg";
import drRoomAttached from "../../../../assets/Interior/Dressing/RoomType/BedroomAttachedDressArea.jpg";
import drRoomOpen from "../../../../assets/Interior/Dressing/RoomType/OpenWardrobeLayout.jpg";
// Wardrobe Type
import drWardrobeSliding from "../../../../assets/Interior/Dressing/WardrobeType/SlidingDoorWardrobe.jpg";
import drWardrobeHinged from "../../../../assets/Interior/Dressing/WardrobeType/HingedDoorWardrobe.jpg";
import drWardrobeGlass from "../../../../assets/Interior/Dressing/WardrobeType/GlassDoorWardrobe.jpg";
import drWardrobeOpen from "../../../../assets/Interior/Dressing/WardrobeType/OpenShelvingWardrobe.jpg";
// Wardrobe Height
import drHeight7ft from "../../../../assets/Interior/Dressing/WardrobeHeight/SevenFtHeight.png";
import drHeightCeiling from "../../../../assets/Interior/Dressing/WardrobeHeight/CeilingHeightWardrobe.jpg";
import drHeightLoft from "../../../../assets/Interior/Dressing/WardrobeHeight/LoftIncluded.jpg";
// Dressing Table Style
import drTableWallMounted from "../../../../assets/Interior/Dressing/DressingTable/WallMounted.jpg";
import drTableFullLength from "../../../../assets/Interior/Dressing/DressingTable/FullLengthUnit.jpg";
import drTableCompact from "../../../../assets/Interior/Dressing/DressingTable/CompactTable.jpg";
// Mirror Type
import drMirrorFullLength from "../../../../assets/Interior/Dressing/MirrorType/FullLengthMirror.jpg";
import drMirrorFramed from "../../../../assets/Interior/Dressing/MirrorType/FramedMirror.jpg";
import drMirrorLED from "../../../../assets/Interior/Dressing/MirrorType/LEDBacklitMirror.jpg";
// Wall Treatments
import drWallMirrorPanels from "../../../../assets/Interior/Dressing/WallTreatments/MirrorPanels.jpeg";
import drWallTextured from "../../../../assets/Interior/Dressing/WallTreatments/TexturedPaint.jfif";
import drWallWallpaper from "../../../../assets/Interior/Dressing/WallTreatments/Wallpaper.jpg";
// Curtain Style
import drCurtainBlackout from "../../../../assets/Interior/Dressing/CurtainStyle/BlackoutCurtain.jpg";
import drCurtainRoman from "../../../../assets/Interior/Dressing/CurtainStyle/RomanBlinds.jpg";
import drCurtainSheer from "../../../../assets/Interior/Dressing/CurtainStyle/SheerCurtain.jpg";
// Seating in Dress Area
import drSeatOttoman from "../../../../assets/Interior/Dressing/SeatingArea/Ottoman.jpg";
import drSeatStool from "../../../../assets/Interior/Dressing/SeatingArea/Stool.jpg";
import drSeatBench from "../../../../assets/Interior/Dressing/SeatingArea/Bench.jpg";
import drSeatNone from "../../../../assets/Interior/Dressing/SeatingArea/WithoutSeating.jpg";
// Shoe Storage
import drShoeOpen from "../../../../assets/Interior/Dressing/ShoeStorage/OpenShoeRack.jpg";
import drShoeClosed from "../../../../assets/Interior/Dressing/ShoeStorage/ClosedShoeCabinet.jpg";
import drShoePullOut from "../../../../assets/Interior/Dressing/ShoeStorage/PullOutShoeStorage.jpg";
// Lighting Preference
import drLightLEDStrip from "../../../../assets/Interior/Dressing/Lighting/LEDStripWardrobe.jpg";
import drLightSpot from "../../../../assets/Interior/Dressing/Lighting/SpotLights.jpg";
import drLightPendant from "../../../../assets/Interior/Dressing/Lighting/PendantLight.jpeg";
// Floor
import drFloorMarble from "../../../../assets/Interior/Dressing/Floor/Marble.jpg";
import drFloorTiles from "../../../../assets/Interior/Dressing/Floor/Tiles.jpg";
import drFloorWood from "../../../../assets/Interior/Dressing/Floor/WoodenFlooring.jpg";
// Design Theme (12)
import drThemeModern from "../../../../assets/Interior/Dressing/Theme/Modern.jfif";
import drThemeLuxury from "../../../../assets/Interior/Dressing/Theme/LuxuryModern.jfif";
import drThemeContemporary from "../../../../assets/Interior/Dressing/Theme/Contemporary.jfif";
import drThemeMinimalist from "../../../../assets/Interior/Dressing/Theme/Minimalist.jfif";
import drThemeTraditional from "../../../../assets/Interior/Dressing/Theme/Traditional.jfif";
import drThemeFarmhouse from "../../../../assets/Interior/Dressing/Theme/Farmhouse.jfif";
import drThemeScandinavian from "../../../../assets/Interior/Dressing/Theme/Scandinavian.jfif";
import drThemeBohemian from "../../../../assets/Interior/Dressing/Theme/Bohemian.jfif";
import drThemeEclectic from "../../../../assets/Interior/Dressing/Theme/Eclectic.jfif";
import drThemeRetro from "../../../../assets/Interior/Dressing/Theme/Retro.jfif";
import drThemeMidcentury from "../../../../assets/Interior/Dressing/Theme/MidcenturyModern.jfif";
import drThemeRustic from "../../../../assets/Interior/Dressing/Theme/RusticIndustrial.jfif";
// Color Preference (6)
import drColorDark from "../../../../assets/Interior/Dressing/Color/Dark.jfif";
import drColorBoldBright from "../../../../assets/Interior/Dressing/Color/BoldBright.jfif";
import drColorWarm from "../../../../assets/Interior/Dressing/Color/Warm.jfif";
import drColorCool from "../../../../assets/Interior/Dressing/Color/Cool.jfif";
import drColorNeutrals from "../../../../assets/Interior/Dressing/Color/Neutrals.jfif";
import drColorMinimal from "../../../../assets/Interior/Dressing/Color/Minimal.jfif";
// Material Finish (3)
import drFinishGlossy from "../../../../assets/Interior/Dressing/Finish/Glossy.jfif";
import drFinishMatt from "../../../../assets/Interior/Dressing/Finish/Matt.jfif";
import drFinishSatin from "../../../../assets/Interior/Dressing/Finish/Satin.jfif";

// ─── REAL WASHROOM IMAGES (from client) ───────────────────────────────────────
// Washroom Type
import wTypeMaster from "../../../../assets/Interior/Washroom/WashroomType/MasterBathroom.jpg";
import wTypeParents from "../../../../assets/Interior/Washroom/WashroomType/ParentsBathroom.jpg";
import wTypeKids from "../../../../assets/Interior/Washroom/WashroomType/KidsBathroom.jpg";
import wTypeGuest from "../../../../assets/Interior/Washroom/WashroomType/GuestBathroom.jpg";
import wTypeCommon from "../../../../assets/Interior/Washroom/WashroomType/CommonToilet.jpg";
// Sanitary Ware Style
import wWcWallHung from "../../../../assets/Interior/Washroom/SanitaryWare/WallHungWC.jpg";
import wWcFloorMounted from "../../../../assets/Interior/Washroom/SanitaryWare/FloorMountedWC.jpg";
import wWcOnePiece from "../../../../assets/Interior/Washroom/SanitaryWare/OnePieceWC.jpg";
// Wash Basin Type
import wBasinCounter from "../../../../assets/Interior/Washroom/WashBasin/CounterTopBasin.jpg";
import wBasinWallHung from "../../../../assets/Interior/Washroom/WashBasin/WallHungBasin.jpg";
import wBasinUnderCounter from "../../../../assets/Interior/Washroom/WashBasin/UnderCounterBasin.jpg";
// Shower Area
import wShowerOpen from "../../../../assets/Interior/Washroom/ShowerArea/OpenShower.jpg";
import wShowerGlass from "../../../../assets/Interior/Washroom/ShowerArea/GlassPartition.jpg";
import wShowerCubicle from "../../../../assets/Interior/Washroom/ShowerArea/ShowerCubicle.jpg";
import wShowerBathtub from "../../../../assets/Interior/Washroom/ShowerArea/Bathtub.jpg";
// Curtain / Screen Option
import wScreenGlass from "../../../../assets/Interior/Washroom/ShowerScreen/GlassPartition.jpg";
import wScreenCurtain from "../../../../assets/Interior/Washroom/ShowerScreen/ShowerCurtain.jpg";
// Vanity Unit
import wVanityWith from "../../../../assets/Interior/Washroom/VanityUnit/WithVanity.jpg";
import wVanityWithout from "../../../../assets/Interior/Washroom/VanityUnit/WithoutVanity.jpg";
// Mirror Style
import wMirrorPlain from "../../../../assets/Interior/Washroom/MirrorStyle/PlainMirror.jpg";
import wMirrorLED from "../../../../assets/Interior/Washroom/MirrorStyle/LEDMirror.jpg";
import wMirrorCabinet from "../../../../assets/Interior/Washroom/MirrorStyle/MirrorCabinet.jpg";
// Storage Provision
import wStorageUnderBasin from "../../../../assets/Interior/Washroom/Storage/UnderBasinStorage.jpg";
import wStorageWallCabinet from "../../../../assets/Interior/Washroom/Storage/WallCabinet.jpg";
import wStorageNiche from "../../../../assets/Interior/Washroom/Storage/NicheShelf.jpg";
// Faucet / Fitting Finish
import wFaucetChrome from "../../../../assets/Interior/Washroom/Faucet/Chrome.jfif";
import wFaucetBlack from "../../../../assets/Interior/Washroom/Faucet/MatteBlack.jfif";
import wFaucetGold from "../../../../assets/Interior/Washroom/Faucet/RoseGold.jfif";
import wFaucetNickel from "../../../../assets/Interior/Washroom/Faucet/BrushedNickel.jfif";
// Wall Treatments
import wWallFullTiles from "../../../../assets/Interior/Washroom/WallTreatments/FullHeightTiles.jpg";
import wWallAccent from "../../../../assets/Interior/Washroom/WallTreatments/AccentTiles.jfif";
import wWallTextured from "../../../../assets/Interior/Washroom/WallTreatments/TexturedTiles.jfif";
import wWallPanel from "../../../../assets/Interior/Washroom/WallTreatments/DesignerPanelTiles.jfif";
// Flooring Type
import wFloorAntiskid from "../../../../assets/Interior/Washroom/Floor/AntiSkidTiles.jpg";
import wFloorMarble from "../../../../assets/Interior/Washroom/Floor/Marble.jpg";
import wFloorWood from "../../../../assets/Interior/Washroom/Floor/WoodFinishTiles.jpg";
// Shower Fittings
import wShowerFitOverhead from "../../../../assets/Interior/Washroom/ShowerFittings/OverheadShower.jpg";
import wShowerFitHand from "../../../../assets/Interior/Washroom/ShowerFittings/HandShower.jpg";
import wShowerFitRain from "../../../../assets/Interior/Washroom/ShowerFittings/RainShower.jpg";
// Water Heater Provision
import wHeaterConcealed from "../../../../assets/Interior/Washroom/WaterHeater/GeyserConcealed.jfif";
import wHeaterVisible from "../../../../assets/Interior/Washroom/WaterHeater/GeyserVisible.jfif";
import wHeaterNotRequired from "../../../../assets/Interior/Washroom/WaterHeater/GeyserNotRequired.jfif";
// Lighting Preference
import wLightCoolWhite from "../../../../assets/Interior/Washroom/Lighting/CoolWhite.jfif";
import wLightMirror from "../../../../assets/Interior/Washroom/Lighting/MirrorLights.jfif";
import wLightWarmWhite from "../../../../assets/Interior/Washroom/Lighting/WarmWhite.jfif";
// Design Theme (6)
import wThemeModern from "../../../../assets/Interior/Washroom/Theme/Modern.jpg";
import wThemeLuxury from "../../../../assets/Interior/Washroom/Theme/LuxuryModern.jpg";
import wThemeContemporary from "../../../../assets/Interior/Washroom/Theme/Contemporary.jpg";
import wThemeBohemian from "../../../../assets/Interior/Washroom/Theme/Bohemian.jpg";
import wThemeRetro from "../../../../assets/Interior/Washroom/Theme/Retro.jpg";
import wThemeScandinavian from "../../../../assets/Interior/Washroom/Theme/Scandinavian.jpg";
// Color Preference (6)
import wColorDark from "../../../../assets/Interior/Washroom/Color/Dark.jpg";
import wColorBoldBright from "../../../../assets/Interior/Washroom/Color/BoldBright.jpg";
import wColorWarm from "../../../../assets/Interior/Washroom/Color/Warm.jpg";
import wColorCool from "../../../../assets/Interior/Washroom/Color/Cool.jpg";
import wColorNeutrals from "../../../../assets/Interior/Washroom/Color/Neutrals.jpg";
import wColorOther from "../../../../assets/Interior/Washroom/Color/Other.jpg";

// ─── REAL FOYER / VERANDAH / LOBBY IMAGES (from client) ───────────────────────
// Space Type
import fSpaceFoyer from "../../../../assets/Interior/Foyer/SpaceType/Foyer.jpg";
import fSpaceVerandah from "../../../../assets/Interior/Foyer/SpaceType/Verandah.jpg";
import fSpaceLobby from "../../../../assets/Interior/Foyer/SpaceType/Lobby.jpg";
import fSpaceEntrance from "../../../../assets/Interior/Foyer/SpaceType/EntrancePassage.jpg";
// Primary Use of Space
import fUseWelcome from "../../../../assets/Interior/Foyer/PrimaryUse/WelcomingArea.jpg";
import fUseWaiting from "../../../../assets/Interior/Foyer/PrimaryUse/WaitingArea.jpg";
import fUseCirculation from "../../../../assets/Interior/Foyer/PrimaryUse/CirculationSpace.jpg";
// Seating Provision
import fSeatingYes from "../../../../assets/Interior/Foyer/Seating/FoyerSeating.jpg";
// Seating Type
import fSeatTypeLoose from "../../../../assets/Interior/Foyer/SeatingType/LooseChairs.jpg";
import fSeatTypeBench from "../../../../assets/Interior/Foyer/SeatingType/BenchSeating.jpg";
import fSeatTypeConsole from "../../../../assets/Interior/Foyer/SeatingType/ConsoleWithStool.jpg";
import fSeatTypeSwing from "../../../../assets/Interior/Foyer/SeatingType/SwingJhula.jpg";
// Shoe Storage
import fShoeOpen from "../../../../assets/Interior/Foyer/ShoeStorage/OpenRack.jpg";
import fShoeClosed from "../../../../assets/Interior/Foyer/ShoeStorage/ClosedCabinet.jpg";
import fShoeBench from "../../../../assets/Interior/Foyer/ShoeStorage/BenchWithStorage.jpg";
// Console Table
import fConsoleWith from "../../../../assets/Interior/Foyer/ConsoleTable/WithConsoleTable.jpg";
import fConsoleWithout from "../../../../assets/Interior/Foyer/ConsoleTable/WithoutConsoleTable.jpg";
// Mirror Provision
import fMirrorFull from "../../../../assets/Interior/Foyer/Mirror/FullLengthMirror.jpg";
import fMirrorDecor from "../../../../assets/Interior/Foyer/Mirror/DecorativeMirror.jpg";
import fMirrorNone from "../../../../assets/Interior/Foyer/Mirror/NoMirror.jpg";
// Partition / Screen
import fPartitionWood from "../../../../assets/Interior/Foyer/Partition/WoodenPartition.jpg";
import fPartitionMetal from "../../../../assets/Interior/Foyer/Partition/MetalScreen.jpg";
import fPartitionGlass from "../../../../assets/Interior/Foyer/Partition/GlassPartition.jpg";
// Wall Treatments
import fWallPanels from "../../../../assets/Interior/Foyer/WallTreatments/DesignerPanels.jpg";
import fWallWallpaper from "../../../../assets/Interior/Foyer/WallTreatments/Wallpaper.jpg";
import fWallTextured from "../../../../assets/Interior/Foyer/WallTreatments/TexturedPaint.jpg";
import fWallStone from "../../../../assets/Interior/Foyer/WallTreatments/StoneCladding.jpg";
// Ceiling Treatment
import fCeilingPlain from "../../../../assets/Interior/Foyer/Ceiling/PlainCeiling.jpg";
import fCeilingFalse from "../../../../assets/Interior/Foyer/Ceiling/FalseCeiling.jpg";
import fCeilingWood from "../../../../assets/Interior/Foyer/Ceiling/WoodenFinishCeiling.jpg";
// Ventilation Option
import fVentCeilingFan from "../../../../assets/Interior/Foyer/Ventilation/CeilingFan.jpg";
import fVentExhaust from "../../../../assets/Interior/Foyer/Ventilation/ExhaustFan.jpg";
import fVentNatural from "../../../../assets/Interior/Foyer/Ventilation/NaturalVentilation.jpg";
// Lighting Preference
import fLightPendant from "../../../../assets/Interior/Foyer/Lighting/PendantLight.png";
import fLightWall from "../../../../assets/Interior/Foyer/Lighting/WallLights.jpg";
import fLightSpot from "../../../../assets/Interior/Foyer/Lighting/SpotLights.jpg";
import fLightCeiling from "../../../../assets/Interior/Foyer/Lighting/CeilingLight.jpg";
// Flooring Type
import fFloorTile from "../../../../assets/Interior/Foyer/Floor/Tile.jpg";
import fFloorMarble from "../../../../assets/Interior/Foyer/Floor/Marble.jpg";
import fFloorWood from "../../../../assets/Interior/Foyer/Floor/Wooden.jpg";
// Rug / Carpet Provision
import fRugWith from "../../../../assets/Interior/Foyer/RugCarpet/WithRug.jpg";
import fRugWithout from "../../../../assets/Interior/Foyer/RugCarpet/WithoutRug.jpg";
// Safety / Security Features
import fSafetyCCTV from "../../../../assets/Interior/Foyer/Safety/CCTVProvision.jpg";
import fSafetyVideoDoor from "../../../../assets/Interior/Foyer/Safety/VideoDoorPhone.jpg";
import fSafetySmartLock from "../../../../assets/Interior/Foyer/Safety/SmartLock.jpg";
// Decor Elements
import fDecorArtwork from "../../../../assets/Interior/Foyer/Decor/Artwork.jpg";
import fDecorPlants from "../../../../assets/Interior/Foyer/Decor/IndoorPlants.jpg";
import fDecorPhotoWall from "../../../../assets/Interior/Foyer/Decor/PhotoWall.jpg";
import fDecorSculptures from "../../../../assets/Interior/Foyer/Decor/Sculptures.jpg";
// Design Theme (6)
import fThemeModern from "../../../../assets/Interior/Foyer/Theme/Modern.jpg";
import fThemeLuxury from "../../../../assets/Interior/Foyer/Theme/Luxury.jpg";
import fThemeMinimalist from "../../../../assets/Interior/Foyer/Theme/Minimalist.jpg";
import fThemeTraditional from "../../../../assets/Interior/Foyer/Theme/Traditional.jpg";
import fThemeBoho from "../../../../assets/Interior/Foyer/Theme/Boho.jpg";
import fThemeMidcentury from "../../../../assets/Interior/Foyer/Theme/Midcentury.jpg";
// Color Preference (4)
import fColorWhite from "../../../../assets/Interior/Foyer/Color/White.jpg";
import fColorBeige from "../../../../assets/Interior/Foyer/Color/Beige.jpg";
import fColorGrey from "../../../../assets/Interior/Foyer/Color/Grey.jpg";
import fColorGreen from "../../../../assets/Interior/Foyer/Color/Green.jpg";
// Material Finish (3)
import fFinishGlossy from "../../../../assets/Interior/Foyer/Finish/GlossyFinish.jpg";
import fFinishMatt from "../../../../assets/Interior/Foyer/Finish/MattFinish.png";
import fFinishSatin from "../../../../assets/Interior/Foyer/Finish/SatinFinish.png";

// ─── REAL BALCONY IMAGES (from client) ────────────────────────────────────────
// Ceiling Treatment
import baCeilingPlain from "../../../../assets/Interior/Balcony/Ceiling/PlainCeiling.jpeg";
import baCeilingWood from "../../../../assets/Interior/Balcony/Ceiling/WoodenFinishCeiling.jpeg";
import baCeilingPergola from "../../../../assets/Interior/Balcony/Ceiling/Pergola.jpeg";
// Color Preference (6)
import baColorDark from "../../../../assets/Interior/Balcony/Color/Dark.jpg";
import baColorBoldBright from "../../../../assets/Interior/Balcony/Color/BoldBright.jpg";
import baColorWarm from "../../../../assets/Interior/Balcony/Color/Warm.jpg";
import baColorCool from "../../../../assets/Interior/Balcony/Color/Cool.jpg";
import baColorNeutrals from "../../../../assets/Interior/Balcony/Color/Neutrals.jpg";
import baColorMinimal from "../../../../assets/Interior/Balcony/Color/Minimal.jpg";
// Flooring Type
import baFloorAntiskid from "../../../../assets/Interior/Balcony/Floor/AntiSkidTiles.jpeg";
import baFloorGrass from "../../../../assets/Interior/Balcony/Floor/ArtificialGrass.jpeg";
import baFloorStone from "../../../../assets/Interior/Balcony/Floor/NaturalStone.jpeg";
import baFloorWoodDeck from "../../../../assets/Interior/Balcony/Floor/WoodenDeckFlooring.jpeg";
// Lighting Preference
import baLightCeiling from "../../../../assets/Interior/Balcony/Lighting/CeilingLights.jpg";
import baLightFairy from "../../../../assets/Interior/Balcony/Lighting/FairyLights.jpg";
import baLightLanterns from "../../../../assets/Interior/Balcony/Lighting/FloorLanterns.jpg";
import baLightWall from "../../../../assets/Interior/Balcony/Lighting/WallLights.jpg";
// Outdoor Furniture Material
import baFurnitureMetal from "../../../../assets/Interior/Balcony/Furniture/Metal.jpg";
import baFurnitureRattan from "../../../../assets/Interior/Balcony/Furniture/RattanWicker.jpg";
import baFurnitureWood from "../../../../assets/Interior/Balcony/Furniture/Wooden.jpg";
// Planting / Greenery
import baGreeneryPlanters from "../../../../assets/Interior/Balcony/Greenery/WithPlanters.jpeg";
import baGreeneryVertical from "../../../../assets/Interior/Balcony/Greenery/WithVerticalGarden.jpeg";
import baGreeneryHanging from "../../../../assets/Interior/Balcony/Greenery/WithHangingPots.jpeg";
import baGreeneryNone from "../../../../assets/Interior/Balcony/Greenery/WithoutPlants.jpeg";
// Design Theme (9)
import baThemeModern from "../../../../assets/Interior/Balcony/Theme/Modern.jpg";
import baThemeLuxury from "../../../../assets/Interior/Balcony/Theme/Luxury.jpg";
import baThemeContemporary from "../../../../assets/Interior/Balcony/Theme/Contemporary.jpg";
import baThemeMinimalist from "../../../../assets/Interior/Balcony/Theme/Minimalist.jpg";
import baThemeTraditional from "../../../../assets/Interior/Balcony/Theme/Traditional.jpg";
import baThemeBohemian from "../../../../assets/Interior/Balcony/Theme/Bohemian.jpg";
import baThemeRustic from "../../../../assets/Interior/Balcony/Theme/RusticIndustrial.jpg";
import baThemeMidcentury from "../../../../assets/Interior/Balcony/Theme/MidcenturyModern.jpg";
import baThemeVintage from "../../../../assets/Interior/Balcony/Theme/Vintage.jpg";
// Privacy Option
import baPrivacyBamboo from "../../../../assets/Interior/Balcony/Privacy/BambooBlinds.jpg";
import baPrivacyFrosted from "../../../../assets/Interior/Balcony/Privacy/FrostedGlass.jpg";
import baPrivacyCurtains from "../../../../assets/Interior/Balcony/Privacy/OutdoorCurtains.jpg";
import baPrivacyNone from "../../../../assets/Interior/Balcony/Privacy/NoPrivacyScreen.jpg";
// Railing Style
import baRailingGlass from "../../../../assets/Interior/Balcony/Railing/GlassRailing.jpeg";
import baRailingMetal from "../../../../assets/Interior/Balcony/Railing/MetalRailing.jpeg";
import baRailingMSWood from "../../../../assets/Interior/Balcony/Railing/MSWithWoodenTop.jpeg";
// Seating Provision
import baSeatingWith from "../../../../assets/Interior/Balcony/Seating/WithSeating.jpeg";
import baSeatingWithout from "../../../../assets/Interior/Balcony/Seating/WithoutSeating.jpeg";
// Seating Type
import baSeatTypeLoose from "../../../../assets/Interior/Balcony/SeatingType/LooseChairs.jpeg";
import baSeatTypeBuiltin from "../../../../assets/Interior/Balcony/SeatingType/BuiltInBench.jpeg";
import baSeatTypeSwing from "../../../../assets/Interior/Balcony/SeatingType/SwingJhula.jpeg";
import baSeatTypeFloor from "../../../../assets/Interior/Balcony/SeatingType/FloorSeating.jpeg";
// Shade / Cover Option
import baShadeOpen from "../../../../assets/Interior/Balcony/Shade/OpenToSky.jpeg";
import baShadePergola from "../../../../assets/Interior/Balcony/Shade/Pergola.jpeg";
import baShadePolycarbonate from "../../../../assets/Interior/Balcony/Shade/PolycarbonateRoof.jpg";
import baShadeAwning from "../../../../assets/Interior/Balcony/Shade/FabricAwning.jpg";
// Utility Provision
import baUtilityDrying from "../../../../assets/Interior/Balcony/Utility/DryingRack.jpg";
import baUtilityWashing from "../../../../assets/Interior/Balcony/Utility/WashingMachineSpace.jpg";
import baUtilitySink from "../../../../assets/Interior/Balcony/Utility/WithSink.jpg";
import baUtilityNotRequired from "../../../../assets/Interior/Balcony/Utility/NotRequired.jpg";
// Wall Treatments
import baWallStone from "../../../../assets/Interior/Balcony/WallTreatments/StoneCladding.jpeg";
import baWallTextured from "../../../../assets/Interior/Balcony/WallTreatments/TexturedPaint.jpeg";
import baWallWooden from "../../../../assets/Interior/Balcony/WallTreatments/WoodenPanels.jpeg";
import baWallVerticalGarden from "../../../../assets/Interior/Balcony/WallTreatments/VerticalGardenWall.jpeg";

// Dummy image URLs — replace with actual asset imports later
const IMGS = {
  kitchen: {
    l_shape:          kShapeL,
    u_shape:          kShapeU,
    parallel:         kShapeParallel,
    island:           kShapeIsland,
    granite:          kCounterGranite,
    quartz:           kCounterQuartz,
    full_body_tile:   kCounterFullBodyTile,
    backsplash_same:  kDadoSame,
    backsplash_diff:  kDadoDiff,
    backsplash_glass: kDadoGlass,
    storage_with:     kStorageWith,
    storage_without:  kStorageWithout,
    ro_above:         kRoAbove,
    ro_below:         kRoBelow,
    ro_wash:          kRoWash,
    gas_inside:       kGasInside,
    gas_outside:      kGasOutside,
    cooktop:          kCooktop,
    hob:              kHob,
    sink_single:      kSinkSingle,
    sink_double:      kSinkDouble,
    sink_with_tray:   kSinkWithTray,
    sink_without_tray:kSinkWithoutTray,
    chimney_with:     kChimneyWith,
    chimney_without:  kChimneyWithout,
    microwave_with:   kMicrowaveWith,
    microwave_without:kMicrowaveWithout,
    dishwasher_with:  kDishwasherWith,
    dishwasher_without:kDishwasherWithout,
    breakfast_with:   kBreakfastWith,
    breakfast_without:kBreakfastWithout,
    handle_less:      kHandleLess,
    profile_handle:   kHandleProfile,
    ss_brass_handle:  kHandleSSBrass,
    ss_cabinet:       kCabinetSS,
    teendom_box:      kCabinetTeendom,
    floor_tiles:      kFloorTile,
    floor_marble:     kFloorMarble,
    floor_wood:       kFloorWood,
    theme_modern:       kThemeModern,
    theme_luxury:       kThemeLuxuryModern,
    theme_contemporary: kThemeContemporary,
    theme_minimalist:   kThemeMinimalist,
    theme_traditional:  kThemeTraditional,
    theme_farmhouse:    kThemeFarmhouse,
    theme_scandinavian: kThemeScandinavian,
    theme_bohemian:     kThemeBohemian,
    theme_eclectic:     kThemeEclectic,
    theme_retro:        kThemeRetro,
    theme_midcentury:   kThemeMidcentury,
    theme_rustic:       kThemeRustic,
    color_dark:         kColorDark,
    color_bold_bright:  kColorBoldBright,
    color_warm:         kColorWarm,
    color_cool:         kColorCool,
    color_neutrals:     kColorNeutrals,
    glossy:           kFinishGlossy,
    pvc:              kFinishPVC,
    pu:               kFinishPU,
  },
  bedroom: {
    king:             bBedKing,
    queen:            bBedQueen,
    single:           bBedSingle,
    slider_wardrobe:  bWardrobeSlider,
    openable_wardrobe:bWardrobeOpenable,
    dressing_room:    bDressInDressRoom,
    dressing_in_room: bDressInRoom,
    seating:          bSeatingWith,
    seating_without:  bSeatingWithout,
    wall_panel:       bWallPanels,
    wall_wallpaper:   bWallWallpaper,
    wall_textured:    bWallTextured,
    headboard_leather:bHeadboardLeather,
    headboard_velvet: bHeadboardVelvet,
    headboard_linen:  bHeadboardLinen,
    curtain_full:     bCurtainFull,
    curtain_on_window:bCurtainOnWindow,
    curtain_roman:    bCurtainRoman,
    curtain_sheer:    bCurtainSheer,
    floor_tiles:      bFloorTile,
    floor_marble:     bFloorMarble,
    floor_wood:       bFloorWood,
    finish_glossy:    bFinishGlossy,
    finish_matt:      bFinishMatt,
    finish_satin:     bFinishSatin,
    theme_select:     bThemeModern,
    color_select:     bColorWarm,
  },
  living: {
    room_formal:      lRoomFormal,
    room_lounge:      lRoomLounge,
    room_tv:          lRoomTV,
    room_combined:    lRoomCombined,
    l_sofa:           lSofaL,
    sofa_set:         lSofa32,
    sectional:        lSofaSectional,
    recliner:         lSofaRecliner,
    seat_4:           lSeat4,
    seat_6:           lSeat6,
    seat_8:           lSeat8,
    table_wood:       lTableWood,
    table_glass:      lTableGlass,
    table_marble:     lTableMarble,
    table_nested:     lTableNested,
    tv_wall:          lTVWall,
    tv_display:       lTVDisplay,
    tv_storage:       lTVStorage,
    display_with:     lDisplayWith,
    display_without:  lDisplayWithout,
    pooja_with:       lPoojaWith,
    pooja_without:    lPoojaWithout,
    wall_panel:       lWallPanels,
    wall_wallpaper:   lWallWallpaper,
    wall_textured:    lWallTextured,
    wall_stone:       lWallStone,
    curtain_full:     lCurtainFull,
    curtain_on_window:lCurtainOnWindow,
    curtain_roman:    lCurtainRoman,
    curtain_sheer:    lCurtainSheer,
    light_cove:       lLightCove,
    light_chandelier: lLightChandelier,
    light_spot:       lLightSpot,
    floor_tiles:      lFloorTiles,
    floor_marble:     lFloorMarble,
    floor_wood:       lFloorWood,
    rug_with:         lRugWith,
    rug_without:      lRugWithout,
    theme_modern:       lThemeModern,
    theme_luxury:       lThemeLuxury,
    theme_contemporary: lThemeContemporary,
    theme_minimalist:   lThemeMinimalist,
    theme_traditional:  lThemeTraditional,
    theme_farmhouse:    lThemeFarmhouse,
    theme_scandinavian: lThemeScandinavian,
    theme_bohemian:     lThemeBohemian,
    theme_eclectic:     lThemeEclectic,
    theme_retro:        lThemeRetro,
    theme_midcentury:   lThemeMidcentury,
    theme_rustic:       lThemeRustic,
    color_dark:         lColorDark,
    color_bold_bright:  lColorBoldBright,
    color_cool:         lColorCool,
    color_neutrals:     lColorNeutrals,
    finish_glossy:    lFinishGlossy,
    finish_matt:      lFinishMatt,
    finish_satin:     lFinishSatin,
  },
  dining: {
    type_separate:    dTypeSeparate,
    type_open:        dTypeOpen,
    type_nook:        dTypeNook,
    table_4:          dTable4,
    table_6:          dTable6,
    table_8:          dTable8,
    shape_rect:       dShapeRect,
    shape_round:      dShapeRound,
    shape_square:     dShapeSquare,
    shape_oval:       dShapeOval,
    crockery_with:    dCrockeryWith,
    crockery_without: dCrockeryWithout,
    bar_with:         dBarWith,
    bar_without:      dBarWithout,
    wash_with:        dWashWith,
    wash_without:     dWashWithout,
    mirror_with:      dMirrorWith,
    mirror_without:   dMirrorWithout,
    wall_panel:       dWallPanels,
    wall_wallpaper:   dWallWallpaper,
    wall_textured:    dWallTextured,
    wall_mirror:      dWallMirror,
    curtain_full:     dCurtainFull,
    curtain_roman:    dCurtainRoman,
    light_chandelier: dLightChandelier,
    light_cove:       dLightCove,
    light_pendant:    "https://images.unsplash.com/photo-1554995207-c18c203602cb?w=400&q=70",
    floor_marble:     dFloorMarble,
    floor_tiles:      dFloorTiles,
    floor_wood:       dFloorWood,
    theme_modern:       dThemeModern,
    theme_contemporary: dThemeContemporary,
    theme_traditional:  dThemeTraditional,
    theme_farmhouse:    dThemeFarmhouse,
    theme_scandinavian: dThemeScandinavian,
    theme_bohemian:     dThemeBohemian,
    theme_eclectic:     dThemeEclectic,
    theme_retro:        dThemeRetro,
    theme_rustic:       dThemeRustic,
    color_bold_bright:  dColorBoldBright,
    color_warm:         dColorWarm,
    color_neutrals:     dColorNeutrals,
    finish_glossy:    dFinishGlossy,
    finish_matt:      dFinishMatt,
  },
  dressing: {
    room_walkin:      drRoomWalkin,
    room_compact:     drRoomCompact,
    room_attached:    drRoomAttached,
    room_open:        drRoomOpen,
    wardrobe_sliding: drWardrobeSliding,
    wardrobe_hinged:  drWardrobeHinged,
    wardrobe_glass:   drWardrobeGlass,
    wardrobe_open:    drWardrobeOpen,
    height_7ft:       drHeight7ft,
    height_ceiling:   drHeightCeiling,
    height_loft:      drHeightLoft,
    table_wall_mounted: drTableWallMounted,
    table_full_length:  drTableFullLength,
    table_compact:      drTableCompact,
    mirror_full_length: drMirrorFullLength,
    mirror_framed:      drMirrorFramed,
    mirror_led:         drMirrorLED,
    wall_mirror_panels: drWallMirrorPanels,
    wall_textured:      drWallTextured,
    wall_wallpaper:     drWallWallpaper,
    curtain_blackout:   drCurtainBlackout,
    curtain_roman:      drCurtainRoman,
    curtain_sheer:      drCurtainSheer,
    seat_ottoman:       drSeatOttoman,
    seat_stool:         drSeatStool,
    seat_bench:         drSeatBench,
    seat_none:          drSeatNone,
    shoe_open:          drShoeOpen,
    shoe_closed:        drShoeClosed,
    shoe_pull_out:      drShoePullOut,
    light_led_strip:    drLightLEDStrip,
    light_spot:         drLightSpot,
    light_pendant:      drLightPendant,
    floor_marble:       drFloorMarble,
    floor_tiles:        drFloorTiles,
    floor_wood:         drFloorWood,
    theme_modern:       drThemeModern,
    theme_luxury:       drThemeLuxury,
    theme_contemporary: drThemeContemporary,
    theme_minimalist:   drThemeMinimalist,
    theme_traditional:  drThemeTraditional,
    theme_farmhouse:    drThemeFarmhouse,
    theme_scandinavian: drThemeScandinavian,
    theme_bohemian:     drThemeBohemian,
    theme_eclectic:     drThemeEclectic,
    theme_retro:        drThemeRetro,
    theme_midcentury:   drThemeMidcentury,
    theme_rustic:       drThemeRustic,
    color_dark:         drColorDark,
    color_bold_bright:  drColorBoldBright,
    color_warm:         drColorWarm,
    color_cool:         drColorCool,
    color_neutrals:     drColorNeutrals,
    color_minimal:      drColorMinimal,
    finish_glossy:      drFinishGlossy,
    finish_matt:        drFinishMatt,
    finish_satin:       drFinishSatin,
  },
  washroom: {
    type_master:      wTypeMaster,
    type_parents:     wTypeParents,
    type_kids:        wTypeKids,
    type_guest:       wTypeGuest,
    type_common:      wTypeCommon,
    wall_hung_wc:     wWcWallHung,
    floor_wc:         wWcFloorMounted,
    one_piece_wc:     wWcOnePiece,
    basin_counter:    wBasinCounter,
    basin_wall:       wBasinWallHung,
    basin_under:      wBasinUnderCounter,
    shower_open:      wShowerOpen,
    shower_glass:     wShowerGlass,
    shower_cubicle:   wShowerCubicle,
    bathtub:          wShowerBathtub,
    screen_glass:     wScreenGlass,
    screen_curtain:   wScreenCurtain,
    vanity_with:      wVanityWith,
    vanity_without:   wVanityWithout,
    mirror_plain:     wMirrorPlain,
    mirror_led:       wMirrorLED,
    mirror_cabinet:   wMirrorCabinet,
    storage_under_basin: wStorageUnderBasin,
    storage_wall_cabinet: wStorageWallCabinet,
    storage_niche:    wStorageNiche,
    faucet_chrome:    wFaucetChrome,
    faucet_black:     wFaucetBlack,
    faucet_gold:      wFaucetGold,
    faucet_nickel:    wFaucetNickel,
    wall_full_tiles:  wWallFullTiles,
    wall_accent:      wWallAccent,
    wall_textured:    wWallTextured,
    wall_panel:       wWallPanel,
    floor_antiskid:   wFloorAntiskid,
    floor_marble:     wFloorMarble,
    floor_wood:       wFloorWood,
    shower_fit_overhead: wShowerFitOverhead,
    shower_fit_hand:     wShowerFitHand,
    shower_fit_rain:     wShowerFitRain,
    heater_concealed: wHeaterConcealed,
    heater_visible:   wHeaterVisible,
    heater_not_required: wHeaterNotRequired,
    light_cool_white: wLightCoolWhite,
    light_mirror:     wLightMirror,
    light_warm_white: wLightWarmWhite,
    theme_modern:       wThemeModern,
    theme_luxury:       wThemeLuxury,
    theme_contemporary: wThemeContemporary,
    theme_bohemian:     wThemeBohemian,
    theme_retro:        wThemeRetro,
    theme_scandinavian: wThemeScandinavian,
    color_dark:         wColorDark,
    color_bold_bright:  wColorBoldBright,
    color_warm:         wColorWarm,
    color_cool:         wColorCool,
    color_neutrals:     wColorNeutrals,
    color_other:        wColorOther,
  },
  balcony: {
    ceiling_plain:    baCeilingPlain,
    ceiling_wood:     baCeilingWood,
    ceiling_pergola:  baCeilingPergola,
    color_dark:         baColorDark,
    color_bold_bright:  baColorBoldBright,
    color_warm:         baColorWarm,
    color_cool:         baColorCool,
    color_neutrals:     baColorNeutrals,
    color_minimal:      baColorMinimal,
    floor_antiskid:   baFloorAntiskid,
    floor_grass:      baFloorGrass,
    floor_stone:      baFloorStone,
    floor_wood_deck:  baFloorWoodDeck,
    light_ceiling:    baLightCeiling,
    light_fairy:      baLightFairy,
    light_lanterns:   baLightLanterns,
    light_wall:       baLightWall,
    furniture_metal:  baFurnitureMetal,
    furniture_rattan: baFurnitureRattan,
    furniture_wood:   baFurnitureWood,
    planters:         baGreeneryPlanters,
    vertical_garden:  baGreeneryVertical,
    hanging_pots:     baGreeneryHanging,
    no_plants:        baGreeneryNone,
    theme_modern:       baThemeModern,
    theme_luxury:       baThemeLuxury,
    theme_contemporary: baThemeContemporary,
    theme_minimalist:   baThemeMinimalist,
    theme_traditional:  baThemeTraditional,
    theme_bohemian:     baThemeBohemian,
    theme_rustic:       baThemeRustic,
    theme_midcentury:   baThemeMidcentury,
    theme_vintage:      baThemeVintage,
    privacy_bamboo:   baPrivacyBamboo,
    privacy_frosted:  baPrivacyFrosted,
    privacy_curtains: baPrivacyCurtains,
    privacy_none:     baPrivacyNone,
    railing_glass:    baRailingGlass,
    railing_metal:    baRailingMetal,
    railing_ms_wood:  baRailingMSWood,
    seating_with:     baSeatingWith,
    seating_without:  baSeatingWithout,
    seating_loose:    baSeatTypeLoose,
    seating_builtin:  baSeatTypeBuiltin,
    seating_swing:    baSeatTypeSwing,
    seating_floor:    baSeatTypeFloor,
    shade_open:            baShadeOpen,
    shade_pergola:         baShadePergola,
    shade_polycarbonate:   baShadePolycarbonate,
    shade_awning:          baShadeAwning,
    utility_drying:       baUtilityDrying,
    utility_washing:      baUtilityWashing,
    utility_sink:         baUtilitySink,
    utility_not_required: baUtilityNotRequired,
    wall_stone:           baWallStone,
    wall_textured:        baWallTextured,
    wall_wooden:          baWallWooden,
    wall_vertical_garden: baWallVerticalGarden,
  },
  foyer: {
    space_foyer:      fSpaceFoyer,
    space_verandah:   fSpaceVerandah,
    space_lobby:      fSpaceLobby,
    space_entrance:   fSpaceEntrance,
    use_welcome:      fUseWelcome,
    use_waiting:      fUseWaiting,
    use_circulation:  fUseCirculation,
    seating_yes:      fSeatingYes,
    seat_loose:       fSeatTypeLoose,
    seat_bench:       fSeatTypeBench,
    seat_console:     fSeatTypeConsole,
    seat_swing:       fSeatTypeSwing,
    shoe_open:        fShoeOpen,
    shoe_closed:      fShoeClosed,
    shoe_bench:       fShoeBench,
    console_with:     fConsoleWith,
    console_without:  fConsoleWithout,
    mirror_full:      fMirrorFull,
    mirror_decor:     fMirrorDecor,
    mirror_none:      fMirrorNone,
    partition_wood:   fPartitionWood,
    partition_metal:  fPartitionMetal,
    partition_glass:  fPartitionGlass,
    wall_panel:       fWallPanels,
    wall_wallpaper:   fWallWallpaper,
    wall_textured:    fWallTextured,
    wall_stone:       fWallStone,
    ceiling_plain:    fCeilingPlain,
    ceiling_false:    fCeilingFalse,
    ceiling_wood:     fCeilingWood,
    vent_ceiling_fan: fVentCeilingFan,
    vent_exhaust:     fVentExhaust,
    vent_natural:     fVentNatural,
    light_pendant:    fLightPendant,
    light_wall:       fLightWall,
    light_spot:       fLightSpot,
    light_ceiling:    fLightCeiling,
    floor_tiles:      fFloorTile,
    floor_marble:     fFloorMarble,
    floor_wood:       fFloorWood,
    rug_with:         fRugWith,
    rug_without:      fRugWithout,
    safety_cctv:      fSafetyCCTV,
    safety_video_door:fSafetyVideoDoor,
    safety_smart_lock:fSafetySmartLock,
    decor_artwork:    fDecorArtwork,
    decor_plants:     fDecorPlants,
    decor_photo_wall: fDecorPhotoWall,
    decor_sculptures: fDecorSculptures,
    theme_modern:       fThemeModern,
    theme_luxury:       fThemeLuxury,
    theme_minimalist:   fThemeMinimalist,
    theme_traditional:  fThemeTraditional,
    theme_boho:         fThemeBoho,
    theme_midcentury:   fThemeMidcentury,
    color_white:        fColorWhite,
    color_beige:        fColorBeige,
    color_grey:         fColorGrey,
    color_green:        fColorGreen,
    finish_glossy:    fFinishGlossy,
    finish_matt:      fFinishMatt,
    finish_satin:     fFinishSatin,
  },
};

// ─── ROOM DEFINITIONS ─────────────────────────────────────────────────────────
export const ROOM_TYPES = [
  { id: "kitchen",   label: "Kitchen",              icon: "🍳" },
  { id: "bedroom",   label: "Bedroom",              icon: "🛏️" },
  { id: "living",    label: "Living / Drawing Room", icon: "🛋️" },
  { id: "dining",    label: "Dining Area",           icon: "🍽️" },
  { id: "dressing",  label: "Dressing Room",         icon: "👗" },
  { id: "washroom",  label: "Washroom / Toilet",     icon: "🚿" },
  { id: "balcony",   label: "Balcony",               icon: "🌿" },
  { id: "foyer",     label: "Foyer / Verandah / Lobby", icon: "🚪" },
];

// ─── QUESTIONS PER ROOM ────────────────────────────────────────────────────────
// display: "radio"         → plain text radio
// display: "radio_image"   → radio with images (swipe + thumbnail)
// display: "image_select"  → image grid select (no radio, tap to pick)
// "Designer Choice" is always appended automatically in the component

export const ROOM_QUESTIONS = {
  kitchen: [
    {
      id: "kitchenShape",
      label: "Preferred Kitchen Shape",
      display: "image_select",
      options: [
        { id: "l_shape",  label: "L Shape",        img: IMGS.kitchen.l_shape },
        { id: "u_shape",  label: "U Shape",         img: IMGS.kitchen.u_shape },
        { id: "parallel", label: "Parallel",        img: IMGS.kitchen.parallel },
        { id: "island",   label: "Island",          img: IMGS.kitchen.island },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "counterTop",
      label: "Counter Top Material",
      display: "image_select",
      options: [
        { id: "granite",        label: "Granite",         img: IMGS.kitchen.granite },
        { id: "quartz",         label: "Quartz",          img: IMGS.kitchen.quartz },
        { id: "full_body_tile", label: "Full Body Tile",  img: IMGS.kitchen.full_body_tile },
        { id: "designer",       label: "Designer Choice", img: null },
      ],
    },
    {
      id: "backsplash",
      label: "Backsplash / Dado Tile",
      display: "image_select",
      options: [
        { id: "same",     label: "Same as Counter",   img: IMGS.kitchen.backsplash_same },
        { id: "diff",     label: "Different Tile",    img: IMGS.kitchen.backsplash_diff },
        { id: "glass",    label: "Toughened Glass",   img: IMGS.kitchen.backsplash_glass },
        { id: "designer", label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "aboveCounterStorage",
      label: "Above Counter Storage",
      display: "image_select",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.kitchen.storage_with },
        { id: "no",       label: "No",  img: IMGS.kitchen.storage_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "ro",
      label: "RO Location",
      display: "radio_image",
      options: [
        { id: "above_sink",  label: "Above Sink",     img: IMGS.kitchen.ro_above },
        { id: "below_sink",  label: "Below Sink",     img: IMGS.kitchen.ro_below },
        { id: "wash_area",   label: "In Wash Area",   img: IMGS.kitchen.ro_wash },
        { id: "designer",    label: "Designer Choice", img: null },
      ],
    },
    {
      id: "gasCylinder",
      label: "Gas Cylinder Location",
      display: "image_select",
      options: [
        { id: "inside",   label: "Inside Kitchen",  img: IMGS.kitchen.gas_inside },
        { id: "outside",  label: "Outside Kitchen", img: IMGS.kitchen.gas_outside },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "cookingMethod",
      label: "Cooking Method",
      display: "image_select",
      options: [
        { id: "cooktop",  label: "Cooktop", img: IMGS.kitchen.cooktop },
        { id: "hob",      label: "Hob",     img: IMGS.kitchen.hob },
      ],
    },
    {
      id: "sinkType",
      label: "Sink Type & Size",
      display: "image_select",
      options: [
        { id: "single",      label: "Single",       img: IMGS.kitchen.sink_single },
        { id: "double",      label: "Double",       img: IMGS.kitchen.sink_double },
        { id: "with_tray",   label: "With Tray",    img: IMGS.kitchen.sink_with_tray },
        { id: "without_tray",label: "Without Tray", img: IMGS.kitchen.sink_without_tray },
      ],
    },
    {
      id: "chimney", label: "Chimney", display: "image_select",
      options: [
        { id: "yes", label: "Yes", img: IMGS.kitchen.chimney_with },
        { id: "no",  label: "No",  img: IMGS.kitchen.chimney_without },
      ],
    },
    {
      id: "microwave", label: "Microwave / Oven", display: "image_select",
      options: [
        { id: "yes", label: "Yes", img: IMGS.kitchen.microwave_with },
        { id: "no",  label: "No",  img: IMGS.kitchen.microwave_without },
      ],
    },
    {
      id: "dishwasher", label: "Dishwasher", display: "image_select",
      options: [
        { id: "yes", label: "Yes", img: IMGS.kitchen.dishwasher_with },
        { id: "no",  label: "No",  img: IMGS.kitchen.dishwasher_without },
      ],
    },
    {
      id: "breakfastCounter",
      label: "Breakfast Counter",
      display: "image_select",
      options: [
        { id: "yes", label: "Yes", img: IMGS.kitchen.breakfast_with },
        { id: "no",  label: "No",  img: IMGS.kitchen.breakfast_without },
      ],
    },
    {
      id: "handle",
      label: "Handle Style",
      display: "image_select",
      options: [
        { id: "handle_less",  label: "Handle-less",        img: IMGS.kitchen.handle_less },
        { id: "profile",      label: "Profile Handle",     img: IMGS.kitchen.profile_handle },
        { id: "ss_brass",     label: "SS / Brass Handle",  img: IMGS.kitchen.ss_brass_handle },
        { id: "designer",     label: "Designer Choice",    img: null },
      ],
    },
    {
      id: "kitchenCabinet",
      label: "Kitchen Cabinet",
      display: "radio_image",
      options: [
        { id: "ss",       label: "SS Trolley",      img: IMGS.kitchen.ss_cabinet },
        { id: "teendom",  label: "Teendom Box",     img: IMGS.kitchen.teendom_box },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "kitchenFloor",
      label: "Preferable Floor",
      display: "image_select",
      options: [
        { id: "tiles",    label: "Tiles",          img: IMGS.kitchen.floor_tiles },
        { id: "marble",   label: "Italian Marble", img: IMGS.kitchen.floor_marble },
        { id: "wood",     label: "Wooden Planks",  img: IMGS.kitchen.floor_wood },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "kitchenTheme",
      label: "Preferable Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",              img: IMGS.kitchen.theme_modern },
        { id: "luxury",       label: "Luxury Modern",       img: IMGS.kitchen.theme_luxury },
        { id: "contemporary", label: "Contemporary",        img: IMGS.kitchen.theme_contemporary },
        { id: "minimalist",   label: "Minimalist",          img: IMGS.kitchen.theme_minimalist },
        { id: "traditional",  label: "Traditional",         img: IMGS.kitchen.theme_traditional },
        { id: "farmhouse",    label: "Farmhouse",           img: IMGS.kitchen.theme_farmhouse },
        { id: "scandinavian", label: "Scandinavian",        img: IMGS.kitchen.theme_scandinavian },
        { id: "bohemian",     label: "Bohemian",            img: IMGS.kitchen.theme_bohemian },
        { id: "eclectic",     label: "Eclectic",            img: IMGS.kitchen.theme_eclectic },
        { id: "retro",        label: "Retro",               img: IMGS.kitchen.theme_retro },
        { id: "midcentury",   label: "Midcentury Modern",   img: IMGS.kitchen.theme_midcentury },
        { id: "rustic",       label: "Rustic & Industrial", img: IMGS.kitchen.theme_rustic },
        { id: "designer",     label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "kitchenColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "dark",        label: "Dark Colors",          img: IMGS.kitchen.color_dark },
        { id: "bold_bright", label: "Bold & Bright Colors", img: IMGS.kitchen.color_bold_bright },
        { id: "warm",        label: "Warm Colors",          img: IMGS.kitchen.color_warm },
        { id: "cool",        label: "Cool Colors",          img: IMGS.kitchen.color_cool },
        { id: "neutrals",    label: "Neutral Colors",       img: IMGS.kitchen.color_neutrals },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "kitchenFinish",
      label: "Preferred Material Finish",
      display: "image_select",
      options: [
        { id: "glossy_mica", label: "Glossy Mica",    img: IMGS.kitchen.glossy },
        { id: "pvc",         label: "PVC/Acrylic Mica", img: IMGS.kitchen.pvc },
        { id: "pu",          label: "PU Coating",     img: IMGS.kitchen.pu },
        { id: "designer",    label: "Designer Choice", img: null },
      ],
    },
  ],

  bedroom: [
    {
      id: "bedroomType",
      label: "Bedroom Type",
      display: "radio",
      options: [
        { id: "master",  label: "Master Room" },
        { id: "parents", label: "Parents Room" },
        { id: "kids",    label: "Kids Room" },
        { id: "guest",   label: "Guest Room" },
      ],
    },
    {
      id: "bedSize",
      label: "Preferred Bed Size",
      display: "radio_image",
      options: [
        { id: "king",   label: "King Size",  img: IMGS.bedroom.king },
        { id: "queen",  label: "Queen Size", img: IMGS.bedroom.queen },
        { id: "single", label: "Single Bed", img: IMGS.bedroom.single },
      ],
    },
    {
      id: "wardrobeShutter",
      label: "Wardrobe Shutter",
      display: "radio_image",
      options: [
        { id: "slider",   label: "Slider",      img: IMGS.bedroom.slider_wardrobe },
        { id: "openable", label: "Open-able",   img: IMGS.bedroom.openable_wardrobe },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "dressing",
      label: "Dressing",
      display: "radio_image",
      options: [
        { id: "in_room",  label: "In Room",    img: IMGS.bedroom.dressing_in_room },
        { id: "in_dress", label: "In Dress",   img: IMGS.bedroom.dressing_room },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "seatingProvision",
      label: "Seating Provision",
      display: "image_select",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.bedroom.seating },
        { id: "no",       label: "No",  img: IMGS.bedroom.seating_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "wallTreatments",
      label: "Wall Treatments",
      display: "image_select",
      options: [
        { id: "panels",    label: "Designer Panels",  img: IMGS.bedroom.wall_panel },
        { id: "wallpaper", label: "Wallpaper",         img: IMGS.bedroom.wall_wallpaper },
        { id: "textured",  label: "Textured Paint",    img: IMGS.bedroom.wall_textured },
        { id: "designer",  label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "headboardFabric",
      label: "Preferable Headboard Fabric",
      display: "image_select",
      options: [
        { id: "leatherette", label: "Leatherette", img: IMGS.bedroom.headboard_leather },
        { id: "velvet",      label: "Velvet",      img: IMGS.bedroom.headboard_velvet },
        { id: "linen",       label: "Linen",       img: IMGS.bedroom.headboard_linen },
        { id: "designer",    label: "Designer Choice", img: null },
      ],
    },
    {
      id: "curtainStyle",
      label: "Curtain Style",
      display: "image_select",
      options: [
        { id: "full_height", label: "Full Height Curtain", img: IMGS.bedroom.curtain_full },
        { id: "on_window",   label: "On Window Curtain",   img: IMGS.bedroom.curtain_on_window },
        { id: "roman",       label: "Roman Blinds",        img: IMGS.bedroom.curtain_roman },
        { id: "sheer",       label: "Sheer + Blackout",    img: IMGS.bedroom.curtain_sheer },
        { id: "designer",    label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "bedroomFloor",
      label: "Preferable Floor",
      display: "image_select",
      options: [
        { id: "tiles",    label: "Tiles",          img: IMGS.bedroom.floor_tiles },
        { id: "marble",   label: "Italian Marble", img: IMGS.bedroom.floor_marble },
        { id: "wood",     label: "Wooden Planks",  img: IMGS.bedroom.floor_wood },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "bedroomTheme",   label: "Preferable Design Theme / Style", display: "radio_image",
      options: [{ id: "from_images", label: "Select From Images", img: IMGS.bedroom.theme_select }, { id: "designer", label: "Designer Choice", img: null }],
    },
    {
      id: "bedroomColor",   label: "Color Preference", display: "radio_image",
      options: [{ id: "from_images", label: "Select From Images", img: IMGS.bedroom.color_select }, { id: "designer", label: "Designer Choice", img: null }],
    },
    {
      id: "bedroomFinish",  label: "Preferred Material Finish", display: "radio_image",
      options: [
        { id: "glossy",   label: "Glossy Finish", img: IMGS.bedroom.finish_glossy },
        { id: "matt",     label: "Matt Finish",   img: IMGS.bedroom.finish_matt },
        { id: "satin",    label: "Satin Finish",  img: IMGS.bedroom.finish_satin },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
  ],

  living: [
    {
      id: "roomType", label: "Room Type", display: "radio_image",
      options: [
        { id: "formal",   label: "Formal Living Room", img: IMGS.living.room_formal },
        { id: "lounge",   label: "Family Lounge",      img: IMGS.living.room_lounge },
        { id: "tv_room",  label: "TV Room",            img: IMGS.living.room_tv },
        { id: "combined", label: "Combined Living Room", img: IMGS.living.room_combined },
      ],
    },
    {
      id: "sofaType", label: "Sofa Type", display: "radio_image",
      options: [
        { id: "l_shape",    label: "L-Shape Sofa",    img: IMGS.living.l_sofa },
        { id: "3_2",        label: "3+2 Sofa Set",    img: IMGS.living.sofa_set },
        { id: "sectional",  label: "Sectional Sofa",  img: IMGS.living.sectional },
        { id: "recliner",   label: "Recliner Sofa",   img: IMGS.living.recliner },
        { id: "designer",   label: "Designer Choice", img: null },
      ],
    },
    {
      id: "seatingCapacity", label: "Seating Capacity", display: "radio_image",
      options: [
        { id: "4",        label: "4 Seater", img: IMGS.living.seat_4 },
        { id: "6",        label: "6 Seater", img: IMGS.living.seat_6 },
        { id: "8",        label: "8 Seater", img: IMGS.living.seat_8 },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "centerTable", label: "Center Table Style", display: "radio_image",
      options: [
        { id: "wooden",   label: "Wooden Table",     img: IMGS.living.table_wood },
        { id: "glass",    label: "Glass Top Table",  img: IMGS.living.table_glass },
        { id: "marble",   label: "Marble Top Table", img: IMGS.living.table_marble },
        { id: "nested",   label: "Nested Tables",    img: IMGS.living.table_nested },
        { id: "designer", label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "tvUnit", label: "TV Unit", display: "radio_image",
      options: [
        { id: "wall_mounted",  label: "Wall Mounted Unit",      img: IMGS.living.tv_wall },
        { id: "display",       label: "Display with TV Unit",   img: IMGS.living.tv_display },
        { id: "storage",       label: "Storage with TV Unit",   img: IMGS.living.tv_storage },
        { id: "designer",      label: "Designer Choice",        img: null },
      ],
    },
    {
      id: "displayUnit", label: "Display / Showcase Unit", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.living.display_with },
        { id: "no",       label: "No",  img: IMGS.living.display_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "poojaUnit", label: "Pooja Unit", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes",            img: IMGS.living.pooja_with },
        { id: "no",       label: "No",             img: IMGS.living.pooja_without },
        { id: "separate", label: "Separate Room",  img: null },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "livingWall", label: "Wall Treatments", display: "image_select",
      options: [
        { id: "panels",   label: "Designer Panels",  img: IMGS.living.wall_panel },
        { id: "wallpaper",label: "Wallpaper",         img: IMGS.living.wall_wallpaper },
        { id: "textured", label: "Textured Paint",    img: IMGS.living.wall_textured },
        { id: "stone",    label: "Stone Cladding",    img: IMGS.living.wall_stone },
        { id: "designer", label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "livingCurtain", label: "Curtain Style", display: "image_select",
      options: [
        { id: "full",       label: "Full Height Curtain", img: IMGS.living.curtain_full },
        { id: "on_window",  label: "On Window Curtain",   img: IMGS.living.curtain_on_window },
        { id: "roman",      label: "Roman Blinds",        img: IMGS.living.curtain_roman },
        { id: "sheer",      label: "Sheer + Blackout",    img: IMGS.living.curtain_sheer },
        { id: "designer",   label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "lighting", label: "Lighting Preference", display: "image_select",
      options: [
        { id: "cove",        label: "False Ceiling + Cove Light", img: IMGS.living.light_cove },
        { id: "chandelier",  label: "Decorative Chandelier",      img: IMGS.living.light_chandelier },
        { id: "spot",        label: "Spot Lights",                img: IMGS.living.light_spot },
        { id: "designer",    label: "Designer Choice",            img: null },
      ],
    },
    {
      id: "livingFloor", label: "Preferable Floor", display: "image_select",
      options: [
        { id: "tiles",    label: "Tiles",             img: IMGS.living.floor_tiles },
        { id: "marble",   label: "Italian Marble",    img: IMGS.living.floor_marble },
        { id: "wood",     label: "Wooden Flooring",   img: IMGS.living.floor_wood },
        { id: "designer", label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "rugCarpet", label: "Rug / Carpet", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.living.rug_with },
        { id: "no",       label: "No",  img: IMGS.living.rug_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "livingTheme",
      label: "Preferable Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",              img: IMGS.living.theme_modern },
        { id: "luxury",       label: "Luxury Modern",       img: IMGS.living.theme_luxury },
        { id: "contemporary", label: "Contemporary",        img: IMGS.living.theme_contemporary },
        { id: "minimalist",   label: "Minimalist",          img: IMGS.living.theme_minimalist },
        { id: "traditional",  label: "Traditional",         img: IMGS.living.theme_traditional },
        { id: "farmhouse",    label: "Farmhouse",           img: IMGS.living.theme_farmhouse },
        { id: "scandinavian", label: "Scandinavian",        img: IMGS.living.theme_scandinavian },
        { id: "bohemian",     label: "Bohemian",            img: IMGS.living.theme_bohemian },
        { id: "eclectic",     label: "Eclectic",            img: IMGS.living.theme_eclectic },
        { id: "retro",        label: "Retro",               img: IMGS.living.theme_retro },
        { id: "midcentury",   label: "Midcentury Modern",   img: IMGS.living.theme_midcentury },
        { id: "rustic",       label: "Rustic & Industrial", img: IMGS.living.theme_rustic },
        { id: "designer",     label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "livingColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "dark",        label: "Dark Colors",          img: IMGS.living.color_dark },
        { id: "bold_bright", label: "Bold & Bright Colors", img: IMGS.living.color_bold_bright },
        { id: "cool",        label: "Cool Colors",          img: IMGS.living.color_cool },
        { id: "neutrals",    label: "Neutral Colors",       img: IMGS.living.color_neutrals },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "livingFinish", label: "Preferred Material Finish", display: "radio_image",
      options: [
        { id: "glossy",   label: "Glossy Finish", img: IMGS.living.finish_glossy },
        { id: "matt",     label: "Matt Finish",   img: IMGS.living.finish_matt },
        { id: "satin",    label: "Satin Finish",  img: IMGS.living.finish_satin },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
  ],

  dining: [
    {
      id: "diningType", label: "Dining Type", display: "radio_image",
      options: [
        { id: "separate",   label: "Separate Dining Room", img: IMGS.dining.type_separate },
        { id: "open",       label: "Open Dining Area",     img: IMGS.dining.type_open },
        { id: "nook",       label: "Breakfast Nook",       img: IMGS.dining.type_nook },
        { id: "combined",   label: "Combined Dining",      img: null },
      ],
    },
    {
      id: "tableSize", label: "Dining Table Size", display: "radio_image",
      options: [
        { id: "4",          label: "4 Seater",         img: IMGS.dining.table_4 },
        { id: "6",          label: "6 Seater",         img: IMGS.dining.table_6 },
        { id: "8",          label: "8 Seater",         img: IMGS.dining.table_8 },
        { id: "extendable", label: "Extendable Table", img: null },
        { id: "designer",   label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "tableShape", label: "Dining Table Shape", display: "radio_image",
      options: [
        { id: "rect",     label: "Rectangle",      img: IMGS.dining.shape_rect },
        { id: "round",    label: "Round",          img: IMGS.dining.shape_round },
        { id: "square",   label: "Square",         img: IMGS.dining.shape_square },
        { id: "oval",     label: "Oval",           img: IMGS.dining.shape_oval },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "crockeryUnit", label: "Crockery Unit", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.dining.crockery_with },
        { id: "no",       label: "No",  img: IMGS.dining.crockery_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "barUnit", label: "Bar Unit", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.dining.bar_with },
        { id: "no",       label: "No",  img: IMGS.dining.bar_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "washBasin", label: "Wash Basin in Dining", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.dining.wash_with },
        { id: "no",       label: "No",  img: IMGS.dining.wash_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "mirrorWall", label: "Mirror Wall", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.dining.mirror_with }, 
        { id: "no",       label: "No",  img: IMGS.dining.mirror_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "diningWall", label: "Wall Treatments", display: "image_select",
      options: [
        { id: "panels",   label: "Designer Panels",  img: IMGS.dining.wall_panel },
        { id: "wallpaper",label: "Wallpaper",         img: IMGS.dining.wall_wallpaper },
        { id: "textured", label: "Textured Paint",    img: IMGS.dining.wall_textured },
        { id: "mirror",   label: "Mirror Panels",     img: IMGS.dining.wall_mirror },
        { id: "designer", label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "diningCurtain", label: "Curtain Style", display: "image_select",
      options: [
        { id: "full",     label: "Full Height Curtain", img: IMGS.dining.curtain_full },
        { id: "roman",    label: "Roman Blinds",        img: IMGS.dining.curtain_roman },
        { id: "designer", label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "diningLight", label: "Lighting Preference", display: "image_select",
      options: [
        { id: "pendant",   label: "Pendant Lights", img: IMGS.dining.light_pendant },
        { id: "chandelier",label: "Chandelier",     img: IMGS.dining.light_chandelier },
        { id: "cove",      label: "Cove Lighting",  img: IMGS.dining.light_cove },
        { id: "designer",  label: "Designer Choice", img: null },
      ],
    },
    {
      id: "diningFloor", label: "Preferable Floor", display: "image_select",
      options: [
        { id: "tiles",    label: "Tiles",           img: IMGS.dining.floor_tiles },
        { id: "marble",   label: "Italian Marble",  img: IMGS.dining.floor_marble },
        { id: "wood",     label: "Wooden Flooring", img: IMGS.dining.floor_wood },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "diningTheme",
      label: "Preferable Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",              img: IMGS.dining.theme_modern },
        { id: "contemporary", label: "Contemporary",        img: IMGS.dining.theme_contemporary },
        { id: "traditional",  label: "Traditional",         img: IMGS.dining.theme_traditional },
        { id: "farmhouse",    label: "Farmhouse",           img: IMGS.dining.theme_farmhouse },
        { id: "scandinavian", label: "Scandinavian",        img: IMGS.dining.theme_scandinavian },
        { id: "bohemian",     label: "Bohemian",            img: IMGS.dining.theme_bohemian },
        { id: "eclectic",     label: "Eclectic",            img: IMGS.dining.theme_eclectic },
        { id: "retro",        label: "Retro",               img: IMGS.dining.theme_retro },
        { id: "rustic",       label: "Rustic & Industrial", img: IMGS.dining.theme_rustic },
        { id: "designer",     label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "diningColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "bold_bright", label: "Bold & Bright Colors", img: IMGS.dining.color_bold_bright },
        { id: "warm",        label: "Warm Colors",          img: IMGS.dining.color_warm },
        { id: "neutrals",    label: "Neutral Colors",       img: IMGS.dining.color_neutrals },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "diningFinish", label: "Preferred Material Finish", display: "radio_image",
      options: [
        { id: "glossy",   label: "Glossy Finish", img: IMGS.dining.finish_glossy },
        { id: "matt",     label: "Matt Finish",   img: IMGS.dining.finish_matt },
        { id: "satin",    label: "Satin Finish",  img: null },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
  ],

  dressing: [
    {
      id: "dressingRoomType", label: "Room Type", display: "radio_image",
      options: [
        { id: "walkin",    label: "Walk-in Dressing Room",       img: IMGS.dressing.room_walkin },
        { id: "compact",   label: "Compact Dress Area",          img: IMGS.dressing.room_compact },
        { id: "attached",  label: "Bedroom Attached Dress Area", img: IMGS.dressing.room_attached },
        { id: "open",      label: "Open Wardrobe Layout",        img: IMGS.dressing.room_open },
        { id: "designer",  label: "Designer Choice",             img: null },
      ],
    },
    {
      id: "wardrobeType", label: "Wardrobe Type", display: "radio_image",
      options: [
        { id: "sliding",  label: "Sliding Door Wardrobe", img: IMGS.dressing.wardrobe_sliding },
        { id: "hinged",   label: "Hinged Door Wardrobe",  img: IMGS.dressing.wardrobe_hinged },
        { id: "glass",    label: "Glass Door Wardrobe",   img: IMGS.dressing.wardrobe_glass },
        { id: "open",     label: "Open Shelving",         img: IMGS.dressing.wardrobe_open },
        { id: "designer", label: "Designer Choice",       img: null },
      ],
    },
    {
      id: "wardrobeHeight", label: "Wardrobe Height", display: "radio_image",
      options: [
        { id: "7ft",      label: "7 Ft Height",            img: IMGS.dressing.height_7ft },
        { id: "ceiling",  label: "Ceiling Height Wardrobe",img: IMGS.dressing.height_ceiling },
        { id: "loft",     label: "Loft Included",          img: IMGS.dressing.height_loft },
        { id: "designer", label: "Designer Choice",        img: null },
      ],
    },
    {
      id: "dressingTable", label: "Dressing Table Style", display: "radio_image",
      options: [
        { id: "wall_mounted", label: "Wall Mounted",      img: IMGS.dressing.table_wall_mounted },
        { id: "full_length",  label: "Full-Length Unit",  img: IMGS.dressing.table_full_length },
        { id: "compact",      label: "Compact Table",     img: IMGS.dressing.table_compact },
        { id: "designer",     label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "mirrorType", label: "Mirror Type", display: "radio_image",
      options: [
        { id: "full_length", label: "Full-Length Mirror",  img: IMGS.dressing.mirror_full_length },
        { id: "framed",      label: "Framed Mirror",       img: IMGS.dressing.mirror_framed },
        { id: "led",         label: "LED Backlit Mirror",  img: IMGS.dressing.mirror_led },
        { id: "designer",    label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "dressingWall", label: "Wall Treatments", display: "image_select",
      options: [
        { id: "mirror",    label: "Mirror Panels",   img: IMGS.dressing.wall_mirror_panels },
        { id: "textured",  label: "Textured Paint",  img: IMGS.dressing.wall_textured },
        { id: "wallpaper", label: "Wallpaper",       img: IMGS.dressing.wall_wallpaper },
        { id: "designer",  label: "Designer Choice", img: null },
      ],
    },
    {
      id: "dressingCurtain", label: "Curtain Style", display: "image_select",
      options: [
        { id: "blackout", label: "Blackout Curtain", img: IMGS.dressing.curtain_blackout },
        { id: "roman",    label: "Roman Blinds",     img: IMGS.dressing.curtain_roman },
        { id: "sheer",    label: "Sheer Curtain",    img: IMGS.dressing.curtain_sheer },
        { id: "designer", label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "seatInDress", label: "Seating in Dress Area", display: "radio_image",
      options: [
        { id: "ottoman",  label: "Ottoman",    img: IMGS.dressing.seat_ottoman },
        { id: "stool",    label: "Stool",      img: IMGS.dressing.seat_stool },
        { id: "bench",    label: "Bench",      img: IMGS.dressing.seat_bench },
        { id: "none",     label: "No Seating", img: IMGS.dressing.seat_none },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "jewelryStorage", label: "Jewelry / Accessory Storage", display: "radio",
      options: [{ id: "yes", label: "Yes" }, { id: "no", label: "No" }, { id: "designer", label: "Designer Choice" }],
    },
    {
      id: "shoeStorage", label: "Shoe Storage", display: "radio_image",
      options: [
        { id: "open_rack",  label: "Open Shoe Rack",         img: IMGS.dressing.shoe_open },
        { id: "closed",     label: "Closed Shoe Cabinet",    img: IMGS.dressing.shoe_closed },
        { id: "pull_out",   label: "Pull-Out Shoe Storage",  img: IMGS.dressing.shoe_pull_out },
        { id: "designer",   label: "Designer Choice",        img: null },
      ],
    },
    {
      id: "dressingLight", label: "Lighting Preference", display: "image_select",
      options: [
        { id: "led_strip",  label: "LED Strip in Wardrobe", img: IMGS.dressing.light_led_strip },
        { id: "spot",       label: "Spot Lights",           img: IMGS.dressing.light_spot },
        { id: "pendant",    label: "Pendant Light",         img: IMGS.dressing.light_pendant },
        { id: "designer",   label: "Designer Choice",       img: null },
      ],
    },
    {
      id: "dressingFloor", label: "Preferable Floor", display: "image_select",
      options: [
        { id: "tiles",    label: "Tiles",           img: IMGS.dressing.floor_tiles },
        { id: "marble",   label: "Marble",          img: IMGS.dressing.floor_marble },
        { id: "wood",     label: "Wooden Flooring", img: IMGS.dressing.floor_wood },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "dressingTheme",
      label: "Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",              img: IMGS.dressing.theme_modern },
        { id: "luxury",       label: "Luxury Modern",       img: IMGS.dressing.theme_luxury },
        { id: "contemporary", label: "Contemporary",        img: IMGS.dressing.theme_contemporary },
        { id: "minimalist",   label: "Minimalist",          img: IMGS.dressing.theme_minimalist },
        { id: "traditional",  label: "Traditional",         img: IMGS.dressing.theme_traditional },
        { id: "farmhouse",    label: "Farmhouse",           img: IMGS.dressing.theme_farmhouse },
        { id: "scandinavian", label: "Scandinavian",        img: IMGS.dressing.theme_scandinavian },
        { id: "bohemian",     label: "Bohemian",            img: IMGS.dressing.theme_bohemian },
        { id: "eclectic",     label: "Eclectic",            img: IMGS.dressing.theme_eclectic },
        { id: "retro",        label: "Retro",               img: IMGS.dressing.theme_retro },
        { id: "midcentury",   label: "Midcentury Modern",   img: IMGS.dressing.theme_midcentury },
        { id: "rustic",       label: "Rustic & Industrial", img: IMGS.dressing.theme_rustic },
        { id: "designer",     label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "dressingColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "dark",        label: "Dark Colors",          img: IMGS.dressing.color_dark },
        { id: "bold_bright", label: "Bold & Bright Colors", img: IMGS.dressing.color_bold_bright },
        { id: "warm",        label: "Warm Colors",          img: IMGS.dressing.color_warm },
        { id: "cool",        label: "Cool Colors",          img: IMGS.dressing.color_cool },
        { id: "neutrals",    label: "Neutral Colors",       img: IMGS.dressing.color_neutrals },
        { id: "minimal",     label: "Minimal Colors",       img: IMGS.dressing.color_minimal },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "dressingFinish", label: "Preferred Material Finish", display: "radio_image",
      options: [
        { id: "glossy",   label: "Glossy Finish", img: IMGS.dressing.finish_glossy },
        { id: "matt",     label: "Matt Finish",   img: IMGS.dressing.finish_matt },
        { id: "satin",    label: "Satin Finish",  img: IMGS.dressing.finish_satin },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
  ],

  washroom: [
    {
      id: "washroomType", label: "Washroom Type", display: "radio_image",
      options: [
        { id: "master",  label: "Master Bathroom",  img: IMGS.washroom.type_master },
        { id: "parents", label: "Parents Bathroom", img: IMGS.washroom.type_parents },
        { id: "kids",    label: "Kids Bathroom",    img: IMGS.washroom.type_kids },
        { id: "guest",   label: "Guest Bathroom",   img: IMGS.washroom.type_guest },
        { id: "common",  label: "Common Toilet",    img: IMGS.washroom.type_common },
      ],
    },
    {
      id: "sanitaryWare", label: "Sanitary Ware Style", display: "radio_image",
      options: [
        { id: "wall_hung",    label: "Wall Hung WC",      img: IMGS.washroom.wall_hung_wc },
        { id: "floor_mount",  label: "Floor Mounted WC",  img: IMGS.washroom.floor_wc },
        { id: "one_piece",    label: "One Piece WC",      img: IMGS.washroom.one_piece_wc },
        { id: "designer",     label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "washBasinType", label: "Wash Basin Type", display: "radio_image",
      options: [
        { id: "counter_top",    label: "Counter Top Basin",   img: IMGS.washroom.basin_counter },
        { id: "wall_hung",      label: "Wall Hung Basin",     img: IMGS.washroom.basin_wall },
        { id: "under_counter",  label: "Under Counter Basin", img: IMGS.washroom.basin_under },
        { id: "designer",       label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "showerArea", label: "Shower Area", display: "radio_image",
      options: [
        { id: "open",      label: "Open Shower",      img: IMGS.washroom.shower_open },
        { id: "glass",     label: "Glass Partition",  img: IMGS.washroom.shower_glass },
        { id: "cubicle",   label: "Shower Cubicle",   img: IMGS.washroom.shower_cubicle },
        { id: "bathtub",   label: "Bathtub",          img: IMGS.washroom.bathtub },
        { id: "designer",  label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "showerScreen", label: "Curtain / Screen Option", display: "radio_image",
      options: [
        { id: "glass",    label: "Glass Partition", img: IMGS.washroom.screen_glass },
        { id: "curtain",  label: "Shower Curtain",  img: IMGS.washroom.screen_curtain },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "vanityUnit", label: "Vanity Unit", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.washroom.vanity_with },
        { id: "no",       label: "No",  img: IMGS.washroom.vanity_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "mirrorStyle", label: "Mirror Style", display: "radio_image",
      options: [
        { id: "plain",   label: "Plain Mirror",    img: IMGS.washroom.mirror_plain },
        { id: "led",     label: "LED Mirror",      img: IMGS.washroom.mirror_led },
        { id: "cabinet", label: "Mirror Cabinet",  img: IMGS.washroom.mirror_cabinet },
        { id: "designer",label: "Designer Choice", img: null },
      ],
    },
    {
      id: "washroomStorage", label: "Storage Provision", display: "image_select",
      options: [
        { id: "under_basin", label: "Under Basin Storage", img: IMGS.washroom.storage_under_basin },
        { id: "wall_cabinet",label: "Wall Cabinet",        img: IMGS.washroom.storage_wall_cabinet },
        { id: "niche",       label: "Niche Shelf",         img: IMGS.washroom.storage_niche },
        { id: "designer",    label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "faucetFinish", label: "Faucet / Fitting Finish", display: "image_select",
      options: [
        { id: "chrome",   label: "Chrome",        img: IMGS.washroom.faucet_chrome },
        { id: "black",    label: "Matte Black",   img: IMGS.washroom.faucet_black },
        { id: "gold",     label: "Rose Gold",     img: IMGS.washroom.faucet_gold },
        { id: "nickel",   label: "Brushed Nickel",img: IMGS.washroom.faucet_nickel },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "washroomWall", label: "Wall Treatments", display: "image_select",
      options: [
        { id: "full_tiles",  label: "Full Height Tiles",   img: IMGS.washroom.wall_full_tiles },
        { id: "accent",      label: "Accent Tiles",        img: IMGS.washroom.wall_accent },
        { id: "textured",    label: "Textured Tiles",      img: IMGS.washroom.wall_textured },
        { id: "panel",       label: "Designer Panel Tiles",img: IMGS.washroom.wall_panel },
        { id: "designer",    label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "washroomFloor", label: "Flooring Type", display: "image_select",
      options: [
        { id: "antiskid", label: "Anti-Skid Tiles",    img: IMGS.washroom.floor_antiskid },
        { id: "marble",   label: "Marble",             img: IMGS.washroom.floor_marble },
        { id: "wood_fin", label: "Wood Finish Tiles",  img: IMGS.washroom.floor_wood },
        { id: "designer", label: "Designer Choice",    img: null },
      ],
    },
    {
      id: "showerFittings", label: "Shower Fittings", display: "radio_image",
      options: [
        { id: "overhead", label: "Overhead Shower",  img: IMGS.washroom.shower_fit_overhead },
        { id: "hand",     label: "Hand Shower",      img: IMGS.washroom.shower_fit_hand },
        { id: "rain",     label: "Rain Shower",      img: IMGS.washroom.shower_fit_rain },
        { id: "designer", label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "waterHeater", label: "Water Heater Provision", display: "radio_image",
      options: [
        { id: "concealed",    label: "Geyser Concealed",    img: IMGS.washroom.heater_concealed },
        { id: "visible",      label: "Geyser Visible",      img: IMGS.washroom.heater_visible },
        { id: "not_required", label: "Not Required",        img: IMGS.washroom.heater_not_required },
        { id: "designer",     label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "exhaustVent", label: "Exhaust / Ventilation", display: "radio",
      options: [
        { id: "exhaust",  label: "Exhaust Fan" },
        { id: "natural",  label: "Natural Ventilation" },
        { id: "both",     label: "Both" },
        { id: "designer", label: "Designer Choice" },
      ],
    },
    {
      id: "washroomLight", label: "Lighting Preference", display: "image_select",
      options: [
        { id: "cool_white", label: "Cool White",    img: IMGS.washroom.light_cool_white },
        { id: "warm_white", label: "Warm White",    img: IMGS.washroom.light_warm_white },
        { id: "mirror",     label: "Mirror Lights", img: IMGS.washroom.light_mirror },
        { id: "designer",   label: "Designer Choice", img: null },
      ],
    },
    {
      id: "washroomTheme",
      label: "Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",        img: IMGS.washroom.theme_modern },
        { id: "luxury",       label: "Luxury Modern", img: IMGS.washroom.theme_luxury },
        { id: "contemporary", label: "Contemporary",  img: IMGS.washroom.theme_contemporary },
        { id: "bohemian",     label: "Bohemian",      img: IMGS.washroom.theme_bohemian },
        { id: "retro",        label: "Retro",         img: IMGS.washroom.theme_retro },
        { id: "scandinavian", label: "Scandinavian",  img: IMGS.washroom.theme_scandinavian },
        { id: "designer",     label: "Designer Choice", img: null },
      ],
    },
    {
      id: "washroomColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "dark",        label: "Dark Colors",          img: IMGS.washroom.color_dark },
        { id: "bold_bright", label: "Bold & Bright Colors", img: IMGS.washroom.color_bold_bright },
        { id: "warm",        label: "Warm Colors",          img: IMGS.washroom.color_warm },
        { id: "cool",        label: "Cool Colors",          img: IMGS.washroom.color_cool },
        { id: "neutrals",    label: "Neutral Colors",       img: IMGS.washroom.color_neutrals },
        { id: "other",       label: "Other",                img: IMGS.washroom.color_other },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "washroomFinish", label: "Preferred Material Finish", display: "radio",
      options: [{ id: "glossy", label: "Glossy Finish" }, { id: "matt", label: "Matt Finish" }, { id: "satin", label: "Satin Finish" }, { id: "designer", label: "Designer Choice" }],
    },
  ],

  balcony: [
    {
      id: "balconyType", label: "Balcony Type", display: "radio",
      options: [
        { id: "living",   label: "Attached to Living Room" },
        { id: "bedroom",  label: "Attached to Bedroom" },
        { id: "utility",  label: "Utility Balcony" },
        { id: "terrace",  label: "Terrace Balcony" },
      ],
    },
    {
      id: "primaryUse", label: "Primary Use of Balcony", display: "radio",
      options: [
        { id: "sitting",    label: "Sitting Area" },
        { id: "garden",     label: "Garden Space" },
        { id: "drying",     label: "Drying Area" },
        { id: "meditation", label: "Meditation / Yoga" },
        { id: "designer",   label: "Designer Choice" },
      ],
    },
    {
      id: "balconyFloor", label: "Flooring Type", display: "radio_image",
      options: [
        { id: "antiskid",  label: "Anti-Skid Tiles",      img: IMGS.balcony.floor_antiskid },
        { id: "wood_deck", label: "Wooden Deck Flooring", img: IMGS.balcony.floor_wood_deck },
        { id: "grass",     label: "Artificial Grass",     img: IMGS.balcony.floor_grass },
        { id: "stone",     label: "Natural Stone",        img: IMGS.balcony.floor_stone },
        { id: "designer",  label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "railingStyle", label: "Railing Style", display: "radio_image",
      options: [
        { id: "glass",    label: "Glass Railing",        img: IMGS.balcony.railing_glass },
        { id: "metal",    label: "Metal Railing",        img: IMGS.balcony.railing_metal },
        { id: "ms_wood",  label: "MS with Wooden Top",   img: IMGS.balcony.railing_ms_wood },
        { id: "designer", label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "balconySeating", label: "Seating Provision", display: "image_select",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.balcony.seating_with },
        { id: "no",       label: "No",  img: IMGS.balcony.seating_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "seatingType", label: "Seating Type", display: "radio_image",
      options: [
        { id: "loose",    label: "Loose Chairs",    img: IMGS.balcony.seating_loose },
        { id: "builtin",  label: "Built-In Bench",  img: IMGS.balcony.seating_builtin },
        { id: "swing",    label: "Swing / Jhula",   img: IMGS.balcony.seating_swing },
        { id: "floor",    label: "Floor Seating",   img: IMGS.balcony.seating_floor },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "privacyOption", label: "Privacy Option", display: "radio_image",
      options: [
        { id: "bamboo",    label: "Bamboo Blinds",      img: IMGS.balcony.privacy_bamboo },
        { id: "frosted",   label: "Frosted Glass",      img: IMGS.balcony.privacy_frosted },
        { id: "curtains",  label: "Outdoor Curtains",   img: IMGS.balcony.privacy_curtains },
        { id: "none",      label: "No Privacy Screen",  img: IMGS.balcony.privacy_none },
        { id: "designer",  label: "Designer Choice",    img: null },
      ],
    },
    {
      id: "greenery", label: "Planting / Greenery", display: "image_select",
      options: [
        { id: "planters",  label: "Planters",        img: IMGS.balcony.planters },
        { id: "vertical",  label: "Vertical Garden", img: IMGS.balcony.vertical_garden },
        { id: "hanging",   label: "Hanging Pots",    img: IMGS.balcony.hanging_pots },
        { id: "no_plants", label: "No Plants",       img: IMGS.balcony.no_plants },
        { id: "designer",  label: "Designer Choice", img: null },
      ],
    },
    {
      id: "balconyWall", label: "Wall Treatments", display: "image_select",
      options: [
        { id: "stone",    label: "Stone Cladding",   img: IMGS.balcony.wall_stone },
        { id: "textured", label: "Textured Paint",   img: IMGS.balcony.wall_textured },
        { id: "wooden",   label: "Wooden Panels",    img: IMGS.balcony.wall_wooden },
        { id: "vertical", label: "Vertical Garden Wall", img: IMGS.balcony.wall_vertical_garden },
        { id: "designer", label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "ceilingTreatment", label: "Ceiling Treatment", display: "image_select",
      options: [
        { id: "plain",    label: "Plain Ceiling",        img: IMGS.balcony.ceiling_plain },
        { id: "wood_fin", label: "Wooden Finish Ceiling", img: IMGS.balcony.ceiling_wood },
        { id: "pergola",  label: "Pergola",              img: IMGS.balcony.ceiling_pergola },
        { id: "designer", label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "shadeOption", label: "Shade / Cover Option", display: "radio_image",
      options: [
        { id: "open",     label: "Open to Sky",        img: IMGS.balcony.shade_open },
        { id: "pergola",  label: "Pergola",            img: IMGS.balcony.shade_pergola },
        { id: "polycarbonate", label: "Polycarbonate Roof", img: IMGS.balcony.shade_polycarbonate },
        { id: "awning",   label: "Fabric Awning",      img: IMGS.balcony.shade_awning },
        { id: "designer", label: "Designer Choice",    img: null },
      ],
    },
    {
      id: "outdoorFurniture", label: "Outdoor Furniture Material", display: "radio_image",
      options: [
        { id: "metal",    label: "Metal",          img: IMGS.balcony.furniture_metal },
        { id: "rattan",   label: "Rattan / Wicker", img: IMGS.balcony.furniture_rattan },
        { id: "wood",     label: "Wood",           img: IMGS.balcony.furniture_wood },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "utilityProvision", label: "Utility Provision", display: "image_select",
      options: [
        { id: "washing",     label: "Washing Machine Space", img: IMGS.balcony.utility_washing },
        { id: "sink",        label: "With Sink",             img: IMGS.balcony.utility_sink },
        { id: "drying_rack", label: "Drying Rack",           img: IMGS.balcony.utility_drying },
        { id: "not_req",     label: "Not Required",          img: IMGS.balcony.utility_not_required },
        { id: "designer",    label: "Designer Choice",       img: null },
      ],
    },
    {
      id: "balconyLight", label: "Lighting Preference", display: "image_select",
      options: [
        { id: "ceiling",  label: "Ceiling Lights", img: IMGS.balcony.light_ceiling },
        { id: "fairy",    label: "Fairy Lights",   img: IMGS.balcony.light_fairy },
        { id: "lanterns", label: "Floor Lanterns", img: IMGS.balcony.light_lanterns },
        { id: "wall",     label: "Wall Lights",    img: IMGS.balcony.light_wall },
        { id: "designer", label: "Designer Choice",img: null },
      ],
    },
    {
      id: "balconyTheme",
      label: "Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",              img: IMGS.balcony.theme_modern },
        { id: "luxury",       label: "Luxury",               img: IMGS.balcony.theme_luxury },
        { id: "contemporary", label: "Contemporary",        img: IMGS.balcony.theme_contemporary },
        { id: "minimalist",   label: "Minimalist",          img: IMGS.balcony.theme_minimalist },
        { id: "traditional",  label: "Traditional",         img: IMGS.balcony.theme_traditional },
        { id: "bohemian",     label: "Bohemian",            img: IMGS.balcony.theme_bohemian },
        { id: "rustic",       label: "Rustic & Industrial", img: IMGS.balcony.theme_rustic },
        { id: "midcentury",   label: "Midcentury Modern",   img: IMGS.balcony.theme_midcentury },
        { id: "vintage",      label: "Vintage",             img: IMGS.balcony.theme_vintage },
        { id: "designer",     label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "balconyColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "dark",        label: "Dark Colors",          img: IMGS.balcony.color_dark },
        { id: "bold_bright", label: "Bold & Bright Colors", img: IMGS.balcony.color_bold_bright },
        { id: "warm",        label: "Warm Colors",          img: IMGS.balcony.color_warm },
        { id: "cool",        label: "Cool Colors",          img: IMGS.balcony.color_cool },
        { id: "neutrals",    label: "Neutral Colors",       img: IMGS.balcony.color_neutrals },
        { id: "minimal",     label: "Minimal Colors",       img: IMGS.balcony.color_minimal },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "balconyFinish", label: "Preferred Material Finish", display: "radio",
      options: [{ id: "glossy", label: "Glossy Finish" }, { id: "matt", label: "Matt Finish" }, { id: "satin", label: "Satin Finish" }, { id: "designer", label: "Designer Choice" }],
    },
  ],

  foyer: [
    {
      id: "spaceType", label: "Space Type", display: "radio_image",
      options: [
        { id: "foyer",    label: "Foyer",            img: IMGS.foyer.space_foyer },
        { id: "verandah", label: "Verandah",         img: IMGS.foyer.space_verandah },
        { id: "lobby",    label: "Lobby",            img: IMGS.foyer.space_lobby },
        { id: "entrance", label: "Entrance Passage", img: IMGS.foyer.space_entrance },
      ],
    },
    {
      id: "primaryUse", label: "Primary Use of Space", display: "radio_image",
      options: [
        { id: "welcome",    label: "Welcoming Area",  img: IMGS.foyer.use_welcome },
        { id: "waiting",    label: "Waiting Area",    img: IMGS.foyer.use_waiting },
        { id: "circulation",label: "Circulation Space",img: IMGS.foyer.use_circulation },
        { id: "shoe",       label: "Shoe Storage",    img: null },
        { id: "designer",   label: "Designer Choice", img: null },
      ],
    },
    {
      id: "foyerSeating", label: "Seating Provision", display: "image_select",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.foyer.seating_yes },
        { id: "no",       label: "No",  img: null },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "foyerSeatingType", label: "Seating Type", display: "radio_image",
      options: [
        { id: "loose",    label: "Loose Chairs",      img: IMGS.foyer.seat_loose },
        { id: "bench",    label: "Bench Seating",     img: IMGS.foyer.seat_bench },
        { id: "console",  label: "Console with Stool",img: IMGS.foyer.seat_console },
        { id: "swing",    label: "Swing / Jhula",     img: IMGS.foyer.seat_swing },
        { id: "designer", label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "shoeStorage", label: "Shoe Storage", display: "radio_image",
      options: [
        { id: "open",     label: "Open Rack",          img: IMGS.foyer.shoe_open },
        { id: "closed",   label: "Closed Cabinet",     img: IMGS.foyer.shoe_closed },
        { id: "bench",    label: "Bench with Storage", img: IMGS.foyer.shoe_bench },
        { id: "not_req",  label: "Not Required",       img: null },
        { id: "designer", label: "Designer Choice",    img: null },
      ],
    },
    {
      id: "consoleTable", label: "Console Table", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.foyer.console_with },
        { id: "no",       label: "No",  img: IMGS.foyer.console_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "mirrorProvision", label: "Mirror Provision", display: "radio_image",
      options: [
        { id: "full",     label: "Full Length Mirror",  img: IMGS.foyer.mirror_full },
        { id: "deco",     label: "Decorative Mirror",   img: IMGS.foyer.mirror_decor },
        { id: "none",     label: "No Mirror",           img: IMGS.foyer.mirror_none },
        { id: "designer", label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "partition", label: "Partition / Screen", display: "image_select",
      options: [
        { id: "wooden",   label: "Wooden Partition",  img: IMGS.foyer.partition_wood },
        { id: "metal",    label: "Metal Screen",      img: IMGS.foyer.partition_metal },
        { id: "glass",    label: "Glass Partition",   img: IMGS.foyer.partition_glass },
        { id: "not_req",  label: "Not Required",      img: null },
        { id: "designer", label: "Designer Choice",   img: null },
      ],
    },
    {
      id: "foyerWall", label: "Wall Treatments", display: "image_select",
      options: [
        { id: "panels",   label: "Designer Panels",   img: IMGS.foyer.wall_panel },
        { id: "wallpaper",label: "Wallpaper",          img: IMGS.foyer.wall_wallpaper },
        { id: "textured", label: "Textured Paint",     img: IMGS.foyer.wall_textured },
        { id: "stone",    label: "Stone Cladding",     img: IMGS.foyer.wall_stone },
        { id: "designer", label: "Designer Choice",    img: null },
      ],
    },
    {
      id: "foyerCeiling", label: "Ceiling Treatment", display: "image_select",
      options: [
        { id: "plain",    label: "Plain Ceiling",         img: IMGS.foyer.ceiling_plain },
        { id: "false",    label: "False Ceiling",         img: IMGS.foyer.ceiling_false },
        { id: "wood_fin", label: "Wooden Finish Ceiling", img: IMGS.foyer.ceiling_wood },
        { id: "designer", label: "Designer Choice",       img: null },
      ],
    },
    {
      id: "foyerVentilation", label: "Ventilation Option", display: "image_select",
      options: [
        { id: "ceiling_fan", label: "Ceiling Fan",         img: IMGS.foyer.vent_ceiling_fan },
        { id: "exhaust",     label: "Exhaust Fan",         img: IMGS.foyer.vent_exhaust },
        { id: "natural",     label: "Natural Ventilation", img: IMGS.foyer.vent_natural },
        { id: "designer",    label: "Designer Choice",     img: null },
      ],
    },
    {
      id: "foyerLight", label: "Lighting Preference", display: "radio_image",
      options: [
        { id: "pendant",     label: "Pendant Light",        img: IMGS.foyer.light_pendant },
        { id: "wall_lights", label: "Wall Lights",          img: IMGS.foyer.light_wall },
        { id: "spot",        label: "Spot Lights",          img: IMGS.foyer.light_spot },
        { id: "ceiling",     label: "Ceiling Light",        img: IMGS.foyer.light_ceiling },
        { id: "chandelier",  label: "Decorative Chandelier",img: IMGS.living.light_chandelier },
        { id: "designer",    label: "Designer Choice",      img: null },
      ],
    },
    {
      id: "foyerFloor", label: "Flooring Type", display: "image_select",
      options: [
        { id: "tiles",    label: "Tiles",           img: IMGS.foyer.floor_tiles },
        { id: "marble",   label: "Italian Marble",  img: IMGS.foyer.floor_marble },
        { id: "wood",     label: "Wooden Flooring", img: IMGS.foyer.floor_wood },
        { id: "stone",    label: "Natural Stone",   img: null },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "rugCarpet", label: "Rug / Carpet Provision", display: "radio_image",
      options: [
        { id: "yes",      label: "Yes", img: IMGS.foyer.rug_with },
        { id: "no",       label: "No",  img: IMGS.foyer.rug_without },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "safetyFeatures", label: "Safety / Security Features", display: "radio_image",
      options: [
        { id: "cctv",       label: "CCTV Provision",   img: IMGS.foyer.safety_cctv },
        { id: "video_door", label: "Video Door Phone", img: IMGS.foyer.safety_video_door },
        { id: "smart_lock", label: "Smart Lock",       img: IMGS.foyer.safety_smart_lock },
        { id: "designer",   label: "Designer Choice",  img: null },
      ],
    },
    {
      id: "decorElements", label: "Decor Elements", display: "image_select",
      options: [
        { id: "artwork",    label: "Artwork",        img: IMGS.foyer.decor_artwork },
        { id: "plants",     label: "Indoor Plants",  img: IMGS.foyer.decor_plants },
        { id: "photo_wall", label: "Photo Wall",     img: IMGS.foyer.decor_photo_wall },
        { id: "sculptures", label: "Sculptures",     img: IMGS.foyer.decor_sculptures },
        { id: "designer",   label: "Designer Choice",img: null },
      ],
    },
    {
      id: "foyerTheme",
      label: "Design Theme / Style",
      display: "radio_image",
      options: [
        { id: "modern",       label: "Modern",       img: IMGS.foyer.theme_modern },
        { id: "luxury",       label: "Luxury Modern",img: IMGS.foyer.theme_luxury },
        { id: "minimalist",   label: "Minimalist",   img: IMGS.foyer.theme_minimalist },
        { id: "traditional",  label: "Traditional",  img: IMGS.foyer.theme_traditional },
        { id: "boho",         label: "Bohemian",     img: IMGS.foyer.theme_boho },
        { id: "midcentury",   label: "Midcentury Modern", img: IMGS.foyer.theme_midcentury },
        { id: "designer",     label: "Designer Choice", img: null },
      ],
    },
    {
      id: "foyerColor",
      label: "Color Preference",
      display: "radio_image",
      options: [
        { id: "white",    label: "White",  img: IMGS.foyer.color_white },
        { id: "beige",    label: "Beige",  img: IMGS.foyer.color_beige },
        { id: "grey",     label: "Grey",   img: IMGS.foyer.color_grey },
        { id: "green",    label: "Green",  img: IMGS.foyer.color_green },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
    {
      id: "foyerFinish", label: "Preferred Material Finish", display: "radio_image",
      options: [
        { id: "glossy",   label: "Glossy Finish",  img: IMGS.foyer.finish_glossy },
        { id: "matt",     label: "Matt Finish",    img: IMGS.foyer.finish_matt },
        { id: "satin",    label: "Satin Finish",   img: IMGS.foyer.finish_satin },
        { id: "natural",  label: "Natural Finish", img: null },
        { id: "designer", label: "Designer Choice", img: null },
      ],
    },
  ],
};